"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useChat = exports.ChatProvider = exports.ChatContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _webApi = require("../utils/web-api");
var _document = require("../utils/document");
var _executeJsRedlineReport = require("../utils/execute-js-redline-report");
var _executeJsScript = require("../utils/execute-js-script");
var _contentRequestFulfillment = require("../utils/content-request-fulfillment");
var _addinRequestAnswerTimeline = require("../utils/addin-request-answer-timeline");
var _focusedDocumentSnapshot = require("../utils/focused-document-snapshot");
var _anchorTrackerRegistry = require("../utils/anchor/anchor-tracker-registry");
var _documentChangesForAgent = require("@common/types/document-changes-for-agent");
var _constants = require("../constants");
var _AnalyticsContext = require("./AnalyticsContext");
var _useDioptraFetch2 = require("../hooks/use-dioptra-fetch");
var _useActionMarkers = require("../hooks/use-action-markers");
var _CardsNotShownContext = require("./CardsNotShownContext");
var _useLocalStorage15 = require("../hooks/use-local-storage");
var _chat = require("../types/chat");
var _tools = require("@common/constants/tools");
var _chatStreamReduction = require("@common/chat-stream/chat-stream-reduction");
var _pollUntilStable = require("@common/utils/pollUntilStable");
var _useResourceQuery = require("@common/hooks/use-resource-query");
var _artifactResource = require("@common/utils/artifact-resource");
var _conversationWorkInFlight = require("../utils/conversation-work-in-flight");
var _streamingFetch = require("@common/utils/streamingFetch");
var _liveReviewOoxml = require("@common/utils/liveReviewOoxml");
var _serialQueue = require("@common/utils/serialQueue");
var _useToolStatusSnapshots = require("@common/hooks/useToolStatusSnapshots");
var _api = require("../utils/api");
var _AuthContext = require("./AuthContext");
var _agentAction = require("../utils/agent-action");
var _chatStreamReader = require("@common/chat-stream/chat-stream-reader");
var _WordDocumentContext = require("./WordDocumentContext");
var _toast = require("../utils/toast");
var _envManager = require("../utils/envManager");
var _file = require("../utils/file");
var _errors = require("../utils/errors");
var _e2eTestHook = require("../utils/e2e-test-hook");
var _sentryReporter = require("../utils/sentry-reporter");
var _redlineAuthorSidesEvent = require("../utils/redline-author-sides-event");
var _RedlineAuthorColorsContext = require("./RedlineAuthorColorsContext");
var _parseStreamedTimestamp = require("@common/components/chat/parseStreamedTimestamp");
var _parseStreamedTurnId2 = require("@common/components/chat/parseStreamedTurnId");
var _streamRetry = require("@common/components/chat/streamRetry");
var _chatMessageFiles = require("@common/schemas/chat-message-files");
var _sentMessageFiles = require("@common/components/chat/sentMessageFiles");
var _localImageUrls = require("@common/utils/local-image-urls");
var _chatAttachmentPaste = require("@common/utils/chat-attachment-paste");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["content", "turnArtifacts"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t25 in e) "default" !== _t25 && {}.hasOwnProperty.call(e, _t25) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t25)) && (i.get || i.set) ? o(f, _t25, i) : f[_t25] = e[_t25]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
function dismissalActionKeyOf(conversationId, actionId) {
  return "".concat(conversationId, ":").concat(actionId);
}
function withoutKey(keys, key) {
  var remainingKeys = new Set(keys);
  remainingKeys.delete(key);
  return remainingKeys;
}

/** A request to scroll the chat to a specific message on next mount — set when
 * the user jumps away from chat (e.g. to the review page via the agent's
 * "View review report" button) so we can return them to where they left off.
 * `actionId` is a message's `getActionIdentifier` value. */

var ChatContext = exports.ChatContext = /*#__PURE__*/(0, _react.createContext)(undefined);
var BASE64_BINARY_CHUNK_SIZE = 0x8000;
var APPLIED_ACTIONS_KEY = "dioptra_applied_actions";
var DISMISSED_ACTIONS_KEY = "dioptra_dismissed_actions";
var REFUSED_ACTIONS_KEY = "dioptra_refused_actions";
var ACTION_RECOVERY_WARNINGS_KEY = "dioptra_action_recovery_warnings";
var ACTION_FAILURES_KEY = "dioptra_action_failures";
var LAST_CONVERSATION_STORAGE_KEY = "dioptra_last_conversation_id";
var SUPERSEDED_ACTIONS_KEY = "dioptra_superseded_actions";
var PART_SUPERSEDED_ACTIONS_KEY = "dioptra_part_superseded_actions";
var ACTIONS_REMOVED_FROM_CONFLICT_GROUPS_KEY = "dioptra_actions_removed_from_conflict_groups";
var RETENTION_DAYS = 30;
var ChatProvider = exports.ChatProvider = function ChatProvider(_ref) {
  var children = _ref.children;
  var _useWordDocument = (0, _WordDocumentContext.useWordDocument)(),
    selectionOoxmlStripped = _useWordDocument.selectionOoxmlStripped,
    selectedText = _useWordDocument.selectedText;
  var applyRedlineAuthorSides = (0, _RedlineAuthorColorsContext.useApplyRedlineAuthorSides)();
  var _useState = (0, _react.useState)(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    selectedConversationId = _useState2[0],
    setSelectedConversationId = _useState2[1];
  var selectedConversationIdRef = (0, _react.useRef)(selectedConversationId);
  selectedConversationIdRef.current = selectedConversationId;
  var conversationSelectionEpochRef = (0, _react.useRef)(0);
  var activePollRef = (0, _react.useRef)(undefined);
  var userStopRequestedRef = (0, _react.useRef)(undefined);
  var recordOutcomeInOrder = (0, _react.useMemo)(_serialQueue.createSerialQueue, []);
  (0, _react.useEffect)(function () {
    (0, _e2eTestHook.setE2eConversationId)(selectedConversationId);
    (0, _sentryReporter.setReporterContext)({
      conversationId: selectedConversationId !== null && selectedConversationId !== void 0 ? selectedConversationId : null
    });
  }, [selectedConversationId]);
  (0, _react.useEffect)(function () {
    (0, _e2eTestHook.setE2eConversationSelector)(setSelectedConversationId);
  }, []);
  (0, _react.useEffect)(function () {
    return _anchorTrackerRegistry.agentDocumentViews.follow();
  }, []);

  // Where to scroll the chat back to when the user returns (e.g. from the
  // review page). Lives here — above PageManager — so it survives ChatPage
  // unmounting on navigation. Consumed (cleared) once restored.
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    pendingScrollTarget = _useState4[0],
    setPendingScrollTarget = _useState4[1];
  var _useState5 = (0, _react.useState)(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedConversation = _useState6[0],
    setSelectedConversation = _useState6[1];
  var selectedConversationRef = (0, _react.useRef)(selectedConversation);
  selectedConversationRef.current = selectedConversation;
  var creatingConversationPromiseRef = (0, _react.useRef)(null);
  var isNewConversationRef = (0, _react.useRef)(false);
  var _useState7 = (0, _react.useState)(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    justCreatedConversationId = _useState8[0],
    setJustCreatedConversationId = _useState8[1];
  var isReplayConversationRef = (0, _react.useRef)(false);
  var chatInputDraftRef = (0, _react.useRef)("");
  var getChatInputDraft = (0, _react.useCallback)(function () {
    return chatInputDraftRef.current;
  }, []);
  var setChatInputDraft = (0, _react.useCallback)(function (value) {
    chatInputDraftRef.current = value;
  }, []);
  var _useState9 = (0, _react.useState)([]),
    _useState0 = _slicedToArray(_useState9, 2),
    attachmentFiles = _useState0[0],
    setAttachmentFiles = _useState0[1];
  var inFocusFileRef = (0, _react.useRef)(null);
  var _useState1 = (0, _react.useState)(new Set()),
    _useState10 = _slicedToArray(_useState1, 2),
    loadingFiles = _useState10[0],
    setLoadingFiles = _useState10[1];
  var loadingFilesRef = (0, _react.useRef)(new Set());
  loadingFilesRef.current = loadingFiles;
  var pendingFileNamesRef = (0, _react.useRef)(new Set());
  var attachmentFilesRef = (0, _react.useRef)([]);
  attachmentFilesRef.current = attachmentFiles;
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    fileToDelete = _useState12[0],
    setFileToDelete = _useState12[1];
  var pendingAttachmentFileUpdateRef = (0, _react.useRef)(Promise.resolve());
  var selectionOoxmlStrippedRef = (0, _react.useRef)(selectionOoxmlStripped);
  selectionOoxmlStrippedRef.current = selectionOoxmlStripped;
  var selectedTextRef = (0, _react.useRef)(selectedText);
  selectedTextRef.current = selectedText;
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    messagesHistory = _useState14[0],
    setMessagesHistory = _useState14[1];
  var recordedRedlineAuthorSidesKey = (0, _react.useMemo)(function () {
    return JSON.stringify(messagesHistory.flatMap(function (message) {
      var _message$turnArtifact, _redlineAuthorSidesOf;
      return ((_message$turnArtifact = message.turnArtifacts) === null || _message$turnArtifact === void 0 ? void 0 : _message$turnArtifact.type) === "tool_result" ? (_redlineAuthorSidesOf = (0, _redlineAuthorSidesEvent.redlineAuthorSidesOf)(message.content)) !== null && _redlineAuthorSidesOf !== void 0 ? _redlineAuthorSidesOf : [] : [];
    }));
  }, [messagesHistory]);
  (0, _react.useEffect)(function () {
    var recordedRedlineAuthorSides = JSON.parse(recordedRedlineAuthorSidesKey);
    if (recordedRedlineAuthorSides.length > 0) applyRedlineAuthorSides(recordedRedlineAuthorSides);
  }, [recordedRedlineAuthorSidesKey, applyRedlineAuthorSides]);
  var _useState15 = (0, _react.useState)(),
    _useState16 = _slicedToArray(_useState15, 2),
    streamingMessageId = _useState16[0],
    setStreamingMessageId = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isConversationLoading = _useState18[0],
    setIsConversationLoading = _useState18[1];
  var _useLocalStorage = (0, _useLocalStorage15.useLocalStorage)(APPLIED_ACTIONS_KEY, new Map(), RETENTION_DAYS),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    appliedActions = _useLocalStorage2[0],
    setAppliedActions = _useLocalStorage2[1];
  var _useLocalStorage3 = (0, _useLocalStorage15.useLocalStorage)(DISMISSED_ACTIONS_KEY, new Map(), RETENTION_DAYS),
    _useLocalStorage4 = _slicedToArray(_useLocalStorage3, 2),
    dismissedActions = _useLocalStorage4[0],
    setDismissedActions = _useLocalStorage4[1];
  var _useLocalStorage5 = (0, _useLocalStorage15.useLocalStorage)(REFUSED_ACTIONS_KEY, new Map(), RETENTION_DAYS),
    _useLocalStorage6 = _slicedToArray(_useLocalStorage5, 2),
    refusedActions = _useLocalStorage6[0],
    setRefusedActions = _useLocalStorage6[1];
  var _useLocalStorage7 = (0, _useLocalStorage15.useLocalStorage)(ACTION_RECOVERY_WARNINGS_KEY, new Map(), RETENTION_DAYS),
    _useLocalStorage8 = _slicedToArray(_useLocalStorage7, 2),
    actionRecoveryWarnings = _useLocalStorage8[0],
    setActionRecoveryWarnings = _useLocalStorage8[1];
  var _useLocalStorage9 = (0, _useLocalStorage15.useLocalStorage)(ACTION_FAILURES_KEY, new Map(), RETENTION_DAYS),
    _useLocalStorage0 = _slicedToArray(_useLocalStorage9, 2),
    actionFailures = _useLocalStorage0[0],
    setActionFailures = _useLocalStorage0[1];
  var _useLocalStorage1 = (0, _useLocalStorage15.useLocalStorage)(SUPERSEDED_ACTIONS_KEY, new Map(), RETENTION_DAYS),
    _useLocalStorage10 = _slicedToArray(_useLocalStorage1, 2),
    supersededActions = _useLocalStorage10[0],
    setSupersededActions = _useLocalStorage10[1];
  var _useLocalStorage11 = (0, _useLocalStorage15.useLocalStorage)(PART_SUPERSEDED_ACTIONS_KEY, new Map(), RETENTION_DAYS),
    _useLocalStorage12 = _slicedToArray(_useLocalStorage11, 2),
    partSupersededActions = _useLocalStorage12[0],
    setPartSupersededActions = _useLocalStorage12[1];
  var _useLocalStorage13 = (0, _useLocalStorage15.useLocalStorage)(ACTIONS_REMOVED_FROM_CONFLICT_GROUPS_KEY, new Map(), RETENTION_DAYS),
    _useLocalStorage14 = _slicedToArray(_useLocalStorage13, 2),
    actionsRemovedFromConflictGroups = _useLocalStorage14[0],
    setActionsRemovedFromConflictGroups = _useLocalStorage14[1];
  var _useState19 = (0, _react.useState)(null),
    _useState20 = _slicedToArray(_useState19, 2),
    streamingMessage = _useState20[0],
    setStreamingMessageState = _useState20[1];
  var streamingMessageRef = (0, _react.useRef)(null);
  var setStreamingMessage = (0, _react.useCallback)(function (next) {
    var resolved = typeof next === "function" ? next(streamingMessageRef.current) : next;
    streamingMessageRef.current = resolved;
    setStreamingMessageState(resolved);
  }, []);
  var _useState21 = (0, _react.useState)(undefined),
    _useState22 = _slicedToArray(_useState21, 2),
    streamingConversationId = _useState22[0],
    setStreamingConversationId = _useState22[1];
  var _useState23 = (0, _react.useState)(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isPolling = _useState24[0],
    setIsPolling = _useState24[1];
  var _useState25 = (0, _react.useState)(false),
    _useState26 = _slicedToArray(_useState25, 2),
    pollDetectedActivity = _useState26[0],
    setPollDetectedActivity = _useState26[1];
  var _useState27 = (0, _react.useState)(new Set()),
    _useState28 = _slicedToArray(_useState27, 2),
    streamingToolResults = _useState28[0],
    setStreamingToolResults = _useState28[1];
  var _useState29 = (0, _react.useState)(new Map()),
    _useState30 = _slicedToArray(_useState29, 2),
    toolCallIdToToolId = _useState30[0],
    setToolCallIdToToolId = _useState30[1];
  var _useState31 = (0, _react.useState)(new Map()),
    _useState32 = _slicedToArray(_useState31, 2),
    toolCallIdToToolName = _useState32[0],
    setToolCallIdToToolName = _useState32[1];
  var _useToolStatusSnapsho = (0, _useToolStatusSnapshots.useToolStatusSnapshots)(),
    toolStatusByCallId = _useToolStatusSnapsho.statusByCallId,
    recordToolStreamEvent = _useToolStatusSnapsho.recordStreamEvent,
    resetToolStatusSnapshots = _useToolStatusSnapsho.resetStatusSnapshots,
    markToolsInProgressAsInterrupted = _useToolStatusSnapsho.markInProgressAsInterrupted;
  var _useState33 = (0, _react.useState)([]),
    _useState34 = _slicedToArray(_useState33, 2),
    artifacts = _useState34[0],
    setArtifacts = _useState34[1];
  // `recentArtifactIds` persists a red dot on the artifact row until the user
  // acknowledges it (cleared by opening the panel). `flashingArtifactIds` is a
  // short-lived glow animation; ids are auto-removed after FLASH_MS.
  var _useState35 = (0, _react.useState)(new Set()),
    _useState36 = _slicedToArray(_useState35, 2),
    recentArtifactIds = _useState36[0],
    setRecentArtifactIds = _useState36[1];
  var _useState37 = (0, _react.useState)(new Set()),
    _useState38 = _slicedToArray(_useState37, 2),
    flashingArtifactIds = _useState38[0],
    setFlashingArtifactIds = _useState38[1];
  var _useState39 = (0, _react.useState)(false),
    _useState40 = _slicedToArray(_useState39, 2),
    plusButtonHasArtifactDot = _useState40[0],
    setPlusButtonHasArtifactDot = _useState40[1];
  var _useState41 = (0, _react.useState)(false),
    _useState42 = _slicedToArray(_useState41, 2),
    plusButtonArtifactDotFlashing = _useState42[0],
    setPlusButtonArtifactDotFlashing = _useState42[1];
  var _useState43 = (0, _react.useState)(false),
    _useState44 = _slicedToArray(_useState43, 2),
    chatArtifactsMenuItemHasArtifactDot = _useState44[0],
    setChatArtifactsMenuItemHasArtifactDot = _useState44[1];
  var filesPanelOpenRef = (0, _react.useRef)(false);
  var recentArtifactIdsRef = (0, _react.useRef)(new Set());
  recentArtifactIdsRef.current = recentArtifactIds;
  // Tracks the pending "glow-then-mark-seen" timer for each artifact so we can
  // cancel/replace it when the same artifact flashes again or the user clicks.
  var artifactFlashTimersRef = (0, _react.useRef)(new Map());

  // Refs to avoid stale closures in stream completion logic
  var streamingToolResultsRef = (0, _react.useRef)(new Set());
  streamingToolResultsRef.current = streamingToolResults;
  var toolCallIdToToolNameRef = (0, _react.useRef)(new Map());
  toolCallIdToToolNameRef.current = toolCallIdToToolName;
  var _useDioptraFetch = (0, _useDioptraFetch2.useDioptraFetch)(),
    dioptraFetch = _useDioptraFetch.dioptraFetch,
    dioptraFetchStream = _useDioptraFetch.dioptraFetchStream;
  var announceResourceChanged = (0, _useResourceQuery.useAnnounceResourceChanged)();
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var authHeaderRef = (0, _react.useRef)(authHeader);
  authHeaderRef.current = authHeader;
  var streamedTurnIdRef = (0, _react.useRef)(null);
  var conversationsAwaitingResponseCheckpointRef = (0, _react.useRef)(new Set());
  var conversationsHandedOffToDatabaseRef = (0, _react.useRef)(new Set());
  var conversationIdByOpenChatStreamRef = (0, _react.useRef)(new Map());
  var previouslySelectedConversationIdRef = (0, _react.useRef)(undefined);
  var documentCaptureRef = (0, _react.useRef)(Promise.resolve());
  var resetSelectedConversationState = (0, _react.useCallback)(function () {
    setAttachmentFiles([]);
    inFocusFileRef.current = null;
    setLoadingFiles(new Set());
    setMessagesHistory([]);
    setStreamingMessageId(undefined);
    setStreamingMessage(null);
    setStreamingToolResults(new Set());
    setToolCallIdToToolId(new Map());
    setToolCallIdToToolName(new Map());
    resetToolStatusSnapshots();
    setArtifacts([]);
    setRecentArtifactIds(new Set());
    setFlashingArtifactIds(new Set());
    setPlusButtonHasArtifactDot(false);
    setPlusButtonArtifactDotFlashing(false);
    setChatArtifactsMenuItemHasArtifactDot(false);
    artifactFlashTimersRef.current.forEach(function (handle) {
      return clearTimeout(handle);
    });
    artifactFlashTimersRef.current.clear();
    setIsPolling(false);
    setPollDetectedActivity(false);
  }, []);
  (0, _react.useEffect)(function () {
    var keepPartial = function keepPartial(byMessage) {
      return new Map(_toConsumableArray(byMessage).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          failure = _ref3[1];
        var parsed = _chat.actionFailureSchema.safeParse(failure);
        return parsed.success && parsed.data.isPartiallyApplied;
      }));
    };
    setActionFailures(function (prev) {
      return new Map(_toConsumableArray(prev).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          conversationId = _ref5[0],
          byMessage = _ref5[1];
        return [conversationId, keepPartial(byMessage)];
      }).filter(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
          byMessage = _ref7[1];
        return byMessage.size > 0;
      }));
    });
  }, [setActionFailures]);
  var applied = (0, _useActionMarkers.useActionMarkers)(appliedActions, setAppliedActions);
  var dismissed = (0, _useActionMarkers.useActionMarkers)(dismissedActions, setDismissedActions);
  var refused = (0, _useActionMarkers.useActionMarkers)(refusedActions, setRefusedActions);
  var recoveryWarnings = (0, _useActionMarkers.useActionMarkers)(actionRecoveryWarnings, setActionRecoveryWarnings);
  var failures = (0, _useActionMarkers.useActionMarkers)(actionFailures, setActionFailures);
  var supersessions = (0, _useActionMarkers.useActionMarkers)(supersededActions, setSupersededActions);
  var partSupersessions = (0, _useActionMarkers.useActionMarkers)(partSupersededActions, setPartSupersededActions);
  var removedFromConflictGroups = (0, _useActionMarkers.useActionMarkers)(actionsRemovedFromConflictGroups, setActionsRemovedFromConflictGroups);
  var saveOutcome = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(conversationId, actionId, outcome, reason) {
      var toolCallId;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            toolCallId = (0, _liveReviewOoxml.toolCallIdFromActionId)(actionId);
            if (!(!conversationId || !toolCallId)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            _context.n = 2;
            return recordOutcomeInOrder("".concat(conversationId, ":").concat(actionId), function () {
              return (0, _api.recordActionOutcome)(dioptraFetch, conversationId, toolCallId, actionId, outcome, reason);
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3, _x4) {
      return _ref8.apply(this, arguments);
    };
  }(), [dioptraFetch, recordOutcomeInOrder]);
  var reportOutcomeFailure = (0, _react.useCallback)(function (error, conversationId, actionId, outcome) {
    sendError(error, {
      component: "ChatContext",
      action: "record_action_outcome",
      conversationId: conversationId,
      actionId: actionId,
      outcome: outcome
    });
  }, [sendError]);
  var recordOutcome = (0, _react.useCallback)(function (conversationId, actionId, outcome, reason) {
    saveOutcome(conversationId, actionId, outcome, reason).catch(function (error) {
      return reportOutcomeFailure(error, conversationId, actionId, outcome);
    });
  }, [saveOutcome, reportOutcomeFailure]);
  var markActionAsApplied = (0, _react.useCallback)(function (conversationId, actionId) {
    failures.clear(conversationId, actionId);
    supersessions.clear(conversationId, actionId);
    partSupersessions.clear(conversationId, actionId);
    applied.set(conversationId, actionId, Date.now());
    recordOutcome(conversationId, actionId, "applied");
  }, [applied, failures, supersessions, partSupersessions, recordOutcome]);
  var markActionAsSuperseded = supersessions.set;
  var getActionSupersession = supersessions.get;
  var markActionAsPartlySuperseded = partSupersessions.set;
  var getActionPartSupersession = partSupersessions.get;
  var markActionAsRemovedFromConflictGroups = (0, _react.useCallback)(function (conversationId, actionId) {
    removedFromConflictGroups.set(conversationId, actionId, Date.now());
  }, [removedFromConflictGroups]);
  var isActionRemovedFromConflictGroups = removedFromConflictGroups.has;
  var markActionAsUnapplied = applied.clear;
  var isActionApplied = applied.has;
  var getActionAppliedAt = applied.get;
  var setDismissedAt = dismissed.set,
    clearDismissedAt = dismissed.clear;
  var dismissalSaveTrackingByActionKeyRef = (0, _react.useRef)(new Map());
  var _useState45 = (0, _react.useState)(new Set()),
    _useState46 = _slicedToArray(_useState45, 2),
    dismissalSavingActionKeys = _useState46[0],
    setDismissalSavingActionKeys = _useState46[1];
  var writeDismissedMarker = (0, _react.useCallback)(function (conversationId, actionId, isDismissed) {
    if (isDismissed) setDismissedAt(conversationId, actionId, Date.now());else clearDismissedAt(conversationId, actionId);
  }, [setDismissedAt, clearDismissedAt]);
  var saveDismissedMarker = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(conversationId, actionId, outcome) {
      var _trackingByActionKey$;
      var actionKey, isDismissed, trackingByActionKey, tracking, saveNumber, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            actionKey = dismissalActionKeyOf(conversationId, actionId);
            isDismissed = outcome === "dismissed";
            trackingByActionKey = dismissalSaveTrackingByActionKeyRef.current;
            tracking = (_trackingByActionKey$ = trackingByActionKey.get(actionKey)) !== null && _trackingByActionKey$ !== void 0 ? _trackingByActionKey$ : {
              latestSaveNumber: 0,
              confirmedIsDismissed: !isDismissed
            };
            tracking.latestSaveNumber += 1;
            saveNumber = tracking.latestSaveNumber;
            trackingByActionKey.set(actionKey, tracking);
            writeDismissedMarker(conversationId, actionId, isDismissed);
            setDismissalSavingActionKeys(function (savingKeys) {
              return new Set(savingKeys).add(actionKey);
            });
            _context2.p = 1;
            _context2.n = 2;
            return saveOutcome(conversationId, actionId, outcome);
          case 2:
            tracking.confirmedIsDismissed = isDismissed;
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t = _context2.v;
            if (tracking.latestSaveNumber === saveNumber) writeDismissedMarker(conversationId, actionId, tracking.confirmedIsDismissed);
            reportOutcomeFailure(_t, conversationId, actionId, outcome);
            throw _t;
          case 4:
            _context2.p = 4;
            if (tracking.latestSaveNumber === saveNumber) setDismissalSavingActionKeys(function (savingKeys) {
              return withoutKey(savingKeys, actionKey);
            });
            return _context2.f(4);
          case 5:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3, 4, 5]]);
    }));
    return function (_x5, _x6, _x7) {
      return _ref9.apply(this, arguments);
    };
  }(), [writeDismissedMarker, saveOutcome, reportOutcomeFailure]);
  var isActionDismissalSaving = (0, _react.useCallback)(function (conversationId, actionId) {
    return dismissalSavingActionKeys.has(dismissalActionKeyOf(conversationId, actionId));
  }, [dismissalSavingActionKeys]);
  var markActionAsDismissed = (0, _react.useCallback)(function (conversationId, actionId) {
    return saveDismissedMarker(conversationId, actionId, "dismissed");
  }, [saveDismissedMarker]);
  var markActionAsUndismissed = (0, _react.useCallback)(function (conversationId, actionId) {
    return saveDismissedMarker(conversationId, actionId, "undismissed");
  }, [saveDismissedMarker]);
  var isActionDismissed = dismissed.has;
  var markActionAsRefused = (0, _react.useCallback)(function (conversationId, messageId) {
    refused.set(conversationId, messageId, Date.now());
  }, [refused]);
  var clearActionRefusal = refused.clear;
  var isActionRefused = refused.has;
  var markActionWithRecoveryWarning = recoveryWarnings.set;
  var getActionRecoveryWarning = recoveryWarnings.get;
  var markActionAsFailed = failures.set;
  var recordActionFailure = (0, _react.useCallback)(function (conversationId, actionId, reason) {
    recordOutcome(conversationId, actionId, "failed", reason);
  }, [recordOutcome]);
  var clearActionFailure = failures.clear;
  var getActionFailure = failures.get;
  var createAndSelectConversation = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(name) {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            // If already creating a conversation, wait for it to complete
            if (!creatingConversationPromiseRef.current) {
              creatingConversationPromiseRef.current = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                var conversation, _t2;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.p = _context3.n) {
                    case 0:
                      _context3.p = 0;
                      _context3.n = 1;
                      return (0, _webApi.createChatConversation)(dioptraFetch, name);
                    case 1:
                      conversation = _context3.v;
                      _context3.n = 2;
                      return setUpNewConversation(conversation);
                    case 2:
                      isNewConversationRef.current = true;
                      setJustCreatedConversationId(conversation.id);
                      setSelectedConversation(conversation);
                      setSelectedConversationId(conversation.id);
                      return _context3.a(2, conversation);
                    case 3:
                      _context3.p = 3;
                      _t2 = _context3.v;
                      console.error("Failed to create conversation:", _t2);
                      sendError(_t2, {
                        component: "ChatContext",
                        action: "create_conversation",
                        conversationName: name
                      });
                      throw _t2;
                    case 4:
                      _context3.p = 4;
                      creatingConversationPromiseRef.current = null;
                      return _context3.f(4);
                    case 5:
                      return _context3.a(2);
                  }
                }, _callee3, null, [[0, 3, 4, 5]]);
              }))();
            }
            return _context4.a(2, creatingConversationPromiseRef.current);
        }
      }, _callee4);
    }));
    return function (_x8) {
      return _ref0.apply(this, arguments);
    };
  }(), [sendError]);
  var selectConversationForReplay = (0, _react.useCallback)(function (conversationId) {
    isReplayConversationRef.current = true;
    setSelectedConversationId(conversationId);
  }, [setSelectedConversationId]);
  var _useState47 = (0, _react.useState)([]),
    _useState48 = _slicedToArray(_useState47, 2),
    documentBackups = _useState48[0],
    setDocumentBackups = _useState48[1];
  var _useState49 = (0, _react.useState)(null),
    _useState50 = _slicedToArray(_useState49, 2),
    restoringBackupName = _useState50[0],
    setRestoringBackupName = _useState50[1];
  var restoreInFlightRef = (0, _react.useRef)(false);
  var _useState51 = (0, _react.useState)(false),
    _useState52 = _slicedToArray(_useState51, 2),
    conversationMatchesOpenDocument = _useState52[0],
    setConversationMatchesOpenDocument = _useState52[1];
  var conversationMatchesOpenDocumentRef = (0, _react.useRef)(false);
  conversationMatchesOpenDocumentRef.current = conversationMatchesOpenDocument;
  var openDocumentOwnsConversation = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(conversationId, fileName) {
      var storedIds, owns, openDocumentName;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _context5.n = 1;
            return (0, _document.fetchPropertyFromDocSettings)(_constants.DIOPTRA_CHAT_CONVERSATION_ID).catch(function () {
              return null;
            });
          case 1:
            storedIds = _context5.v;
            if (!storedIds) {
              _context5.n = 2;
              break;
            }
            owns = storedIds.split(",").map(function (id) {
              return id.trim();
            }).includes(conversationId);
            console.log("\x1B[35m[backup] open document lists ".concat(storedIds.split(",").length, " conversation(s); owns ").concat(conversationId, ": ").concat(owns, "\x1B[0m"));
            return _context5.a(2, owns);
          case 2:
            _context5.n = 3;
            return (0, _document.fetchDocName)();
          case 3:
            openDocumentName = _context5.v;
            console.log("\x1B[35m[backup] no conversation ids in document settings; falling back to name \"".concat(fileName, "\" vs \"").concat(openDocumentName, "\"\x1B[0m"));
            return _context5.a(2, fileName === openDocumentName);
        }
      }, _callee5);
    }));
    return function (_x9, _x0) {
      return _ref10.apply(this, arguments);
    };
  }(), []);
  var refreshDocumentBackups = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(conversationId) {
      var header, backups, _t3;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            header = authHeaderRef.current;
            if (header) {
              _context6.n = 1;
              break;
            }
            setDocumentBackups([]);
            return _context6.a(2);
          case 1:
            _context6.p = 1;
            _context6.n = 2;
            return (0, _api.listDocumentBackups)(header, conversationId);
          case 2:
            backups = _context6.v;
            if (selectedConversationIdRef.current === conversationId) {
              console.log("\x1B[35m[backup] list refreshed conversation=".concat(conversationId, ": ").concat(backups.length, " backups\x1B[0m"));
              setDocumentBackups(backups);
            }
            _context6.n = 4;
            break;
          case 3:
            _context6.p = 3;
            _t3 = _context6.v;
            console.error("\x1B[1;31m[backup] list FAILED conversation=".concat(conversationId, "\x1B[0m"), _t3);
          case 4:
            return _context6.a(2);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x1) {
      return _ref11.apply(this, arguments);
    };
  }(), []);
  var hasAuthHeader = !!authHeader;
  (0, _react.useEffect)(function () {
    setDocumentBackups([]);
    setConversationMatchesOpenDocument(false);
    if (selectedConversationId && hasAuthHeader) {
      void refreshDocumentBackups(selectedConversationId);
    }
  }, [selectedConversationId, hasAuthHeader, refreshDocumentBackups]);
  var captureDocumentCheckpoint = (0, _react.useCallback)(function (request) {
    var trigger = request.trigger,
      target = request.target,
      toolCallId = request.toolCallId,
      turnId = request.turnId,
      capturedAt = request.capturedAt;
    var conversationId = target.conversationId;
    var awaitingCheckpoint = conversationsAwaitingResponseCheckpointRef.current;
    if (!conversationId || !awaitingCheckpoint.has(conversationId)) return documentCaptureRef.current;
    if (!capturedAt) {
      console.error("\x1B[1;31m[backup] capture ABORTED trigger=".concat(trigger, ": the stream event carried no timestamp\x1B[0m"));
      return documentCaptureRef.current;
    }
    awaitingCheckpoint.delete(conversationId);
    var header = authHeaderRef.current;
    if (!header) {
      awaitingCheckpoint.add(conversationId);
      console.error("\x1B[1;31m[backup] capture ABORTED trigger=".concat(trigger, ": no auth header\x1B[0m"));
      return documentCaptureRef.current;
    }
    if (!target.openDocumentOwnsConversation) {
      awaitingCheckpoint.add(conversationId);
      console.log("\x1B[35m[backup] capture SKIPPED trigger=".concat(trigger, ": conversation ").concat(conversationId, " belongs to a different document than the open one\x1B[0m"));
      return documentCaptureRef.current;
    }
    var checkpoint = {
      capturedAt: capturedAt,
      turnId: turnId !== null && turnId !== void 0 ? turnId : streamedTurnIdRef.current,
      toolCallId: toolCallId
    };
    var capture = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var readStartedAt, docBase64, backups, _t4;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            _context7.p = 0;
            readStartedAt = Date.now();
            _context7.n = 1;
            return (0, _document.getDocumentFileToBase64)();
          case 1:
            docBase64 = _context7.v;
            console.log("\x1B[35m[backup] capture trigger=".concat(trigger, " at=").concat(capturedAt, " anchor=").concat(toolCallId !== null && toolCallId !== void 0 ? toolCallId : checkpoint.turnId, ": ").concat(docBase64.length, " base64 chars read in ").concat(Date.now() - readStartedAt, "ms\x1B[0m"));
            _context7.n = 2;
            return (0, _api.uploadDocumentBackup)(header, conversationId, docBase64, checkpoint);
          case 2:
            backups = _context7.v;
            if (selectedConversationIdRef.current === conversationId) {
              setDocumentBackups(backups);
            }
            _context7.n = 4;
            break;
          case 3:
            _context7.p = 3;
            _t4 = _context7.v;
            awaitingCheckpoint.add(conversationId);
            console.error("\x1B[1;31m[backup] capture FAILED trigger=".concat(trigger, " conversation=").concat(conversationId, "\x1B[0m"), _t4);
            sendError(_t4, {
              component: "ChatContext",
              action: "capture_document_checkpoint",
              conversationId: conversationId
            });
          case 4:
            return _context7.a(2);
        }
      }, _callee7, null, [[0, 3]]);
    }))();
    documentCaptureRef.current = capture;
    return capture;
  }, [sendError]);
  var revertDocumentToBackup = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(backup) {
      var conversationId, header, backups, current, response, bytes, binary, i, _t5, _t6;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            if (!restoreInFlightRef.current) {
              _context8.n = 1;
              break;
            }
            console.log("\x1B[35m[backup] restore to ".concat(backup.name, " IGNORED: another restore is already running\x1B[0m"));
            return _context8.a(2);
          case 1:
            conversationId = selectedConversationIdRef.current;
            header = authHeaderRef.current;
            if (!(!conversationId || !header)) {
              _context8.n = 2;
              break;
            }
            console.error("\x1B[1;31m[backup] restore to ".concat(backup.name, " ABORTED: ").concat(!conversationId ? "no selected conversation" : "no auth header", "\x1B[0m"));
            return _context8.a(2);
          case 2:
            restoreInFlightRef.current = true;
            setRestoringBackupName(backup.name);
            _context8.p = 3;
            _context8.n = 4;
            return (0, _api.listDocumentBackups)(header, conversationId);
          case 4:
            backups = _context8.v;
            if (selectedConversationIdRef.current === conversationId) {
              setDocumentBackups(backups);
            }
            current = backups.find(function (candidate) {
              return candidate.name === backup.name;
            });
            if (current) {
              _context8.n = 5;
              break;
            }
            console.error("\x1B[1;31m[backup] restore to ".concat(backup.name, " ABORTED: no longer listed for conversation ").concat(conversationId, "\x1B[0m"));
            (0, _toast.toastError)("That document backup is no longer available");
            return _context8.a(2);
          case 5:
            console.log("\x1B[35m[backup] reverting document to ".concat(current.name, "\x1B[0m"));
            _context8.n = 6;
            return fetch(current.url);
          case 6:
            response = _context8.v;
            if (response.ok) {
              _context8.n = 7;
              break;
            }
            throw new Error("Failed to download document backup: ".concat(response.status));
          case 7:
            _t5 = Uint8Array;
            _context8.n = 8;
            return response.arrayBuffer();
          case 8:
            _t6 = _context8.v;
            bytes = new _t5(_t6);
            binary = "";
            for (i = 0; i < bytes.length; i += BASE64_BINARY_CHUNK_SIZE) {
              binary += String.fromCharCode.apply(String, _toConsumableArray(bytes.subarray(i, i + BASE64_BINARY_CHUNK_SIZE)));
            }
            _context8.n = 9;
            return (0, _document.replaceDocumentFromBase64)(btoa(binary));
          case 9:
            (0, _toast.toastSuccess)("Document restored");
          case 10:
            _context8.p = 10;
            restoreInFlightRef.current = false;
            setRestoringBackupName(null);
            return _context8.f(10);
          case 11:
            return _context8.a(2);
        }
      }, _callee8, null, [[3,, 10, 11]]);
    }));
    return function (_x10) {
      return _ref13.apply(this, arguments);
    };
  }(), []);
  var revertDocumentToLatestBackup = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
    var conversationId, header, backups;
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          conversationId = selectedConversationIdRef.current;
          header = authHeaderRef.current;
          if (!(!conversationId || !header)) {
            _context9.n = 1;
            break;
          }
          return _context9.a(2);
        case 1:
          _context9.n = 2;
          return (0, _api.listDocumentBackups)(header, conversationId);
        case 2:
          backups = _context9.v;
          if (selectedConversationIdRef.current === conversationId) {
            setDocumentBackups(backups);
          }
          if (!(backups.length === 0)) {
            _context9.n = 3;
            break;
          }
          (0, _toast.toastError)("No document backup available for this conversation");
          return _context9.a(2);
        case 3:
          _context9.n = 4;
          return revertDocumentToBackup(backups[0]);
        case 4:
          return _context9.a(2);
      }
    }, _callee9);
  })), [revertDocumentToBackup]);
  var registerFocusedDocument = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(conversationId) {
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.n) {
          case 0:
            pendingAttachmentFileUpdateRef.current = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
              var _fileName, result, _t7;
              return _regenerator().w(function (_context0) {
                while (1) switch (_context0.p = _context0.n) {
                  case 0:
                    _context0.p = 0;
                    _context0.n = 1;
                    return (0, _document.fetchDocName)();
                  case 1:
                    _fileName = _context0.v;
                    _context0.n = 2;
                    return (0, _webApi.createConversationFile)({
                      dioptraFetch: dioptraFetch,
                      conversationId: conversationId,
                      fileName: _fileName,
                      inFocus: true
                    });
                  case 2:
                    result = _context0.v;
                    if (result !== null && result !== void 0 && result.attachment) {
                      inFocusFileRef.current = {
                        id: result.attachment.id,
                        fileName: result.attachment.fileName,
                        inFocus: true,
                        conversationId: conversationId,
                        tokenCount: null
                      };
                    }
                    _context0.n = 5;
                    break;
                  case 3:
                    _context0.p = 3;
                    _t7 = _context0.v;
                    if (!((_t7 === null || _t7 === void 0 ? void 0 : _t7.status) === 404)) {
                      _context0.n = 4;
                      break;
                    }
                    return _context0.a(2);
                  case 4:
                    sendError(_t7 instanceof Error ? _t7 : new Error(String(_t7)), {
                      component: 'ChatContext',
                      action: 'register_focused_document',
                      conversationId: conversationId
                    });
                    throw _t7;
                  case 5:
                    return _context0.a(2);
                }
              }, _callee0, null, [[0, 3]]);
            }))();
            return _context1.a(2, pendingAttachmentFileUpdateRef.current);
        }
      }, _callee1);
    }));
    return function (_x11) {
      return _ref15.apply(this, arguments);
    };
  }(), [sendError]);
  var handleAddFiles = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(files) {
      var supported, unsupported, newFiles, conversationId, newConversation, uploadedAttachments;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.n) {
          case 0:
            supported = files.filter(function (f) {
              return (0, _file.isAllowedAttachmentExtension)(f.name);
            });
            unsupported = files.filter(function (f) {
              return !(0, _file.isAllowedAttachmentExtension)(f.name);
            });
            unsupported.forEach(function (f) {
              return (0, _toast.toastDismissibleError)("".concat(f.name, ": Unsupported file type. Allowed types: ").concat(_file.ALLOWED_ATTACHMENT_EXTENSIONS_LABEL, "."), {
                duration: 10000
              });
            });
            newFiles = (0, _chatAttachmentPaste.uniquelyNamedFiles)(supported, [].concat(_toConsumableArray(attachmentFilesRef.current.map(function (f) {
              return f.fileName;
            })), _toConsumableArray(loadingFilesRef.current), _toConsumableArray(pendingFileNamesRef.current)));
            if (!(newFiles.length === 0)) {
              _context11.n = 1;
              break;
            }
            return _context11.a(2, 0);
          case 1:
            newFiles.forEach(function (f) {
              return pendingFileNamesRef.current.add(f.name);
            });
            setLoadingFiles(function (prev) {
              var newSet = new Set(prev);
              newFiles.forEach(function (file) {
                return newSet.add(file.name);
              });
              return newSet;
            });
            conversationId = selectedConversationId;
            if (conversationId) {
              _context11.n = 3;
              break;
            }
            _context11.n = 2;
            return createAndSelectConversation("New Conversation");
          case 2:
            newConversation = _context11.v;
            conversationId = newConversation.id;
          case 3:
            uploadedAttachments = [];
            _context11.n = 4;
            return Promise.all(newFiles.map(/*#__PURE__*/function () {
              var _ref18 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(file) {
                var base64, response, status, isClientRejection, errorMsg, _t8;
                return _regenerator().w(function (_context10) {
                  while (1) switch (_context10.p = _context10.n) {
                    case 0:
                      _context10.p = 0;
                      _context10.n = 1;
                      return (0, _file.readFileAsBase64)(file);
                    case 1:
                      base64 = _context10.v;
                      _context10.n = 2;
                      return (0, _webApi.createConversationFile)({
                        dioptraFetch: dioptraFetch,
                        conversationId: conversationId,
                        fileName: file.name,
                        fileBase64: base64,
                        inFocus: false
                      });
                    case 2:
                      response = _context10.v;
                      (0, _localImageUrls.rememberLocalImage)(response.attachment.storageUrl, file);
                      uploadedAttachments.push({
                        id: response.attachment.id,
                        fileName: response.attachment.fileName || file.name,
                        inFocus: false,
                        conversationId: conversationId,
                        tokenCount: response.attachment.tokenCount,
                        storageUrl: response.attachment.storageUrl
                      });
                      _context10.n = 4;
                      break;
                    case 3:
                      _context10.p = 3;
                      _t8 = _context10.v;
                      // Per-file error handling: failed uploads show a dismissible toast
                      // while other files in the batch continue uploading.
                      // Expected client-input rejections (4xx — e.g. an unsupported legacy .doc
                      // or an oversized file) are user-correctable, so toast them but don't
                      // report to Sentry as crashes.
                      status = _t8 instanceof _errors.UserFacingError ? _t8.status : undefined;
                      isClientRejection = status !== undefined && status >= 400 && status < 500;
                      if (!isClientRejection) {
                        sendError(_t8 instanceof Error ? _t8 : new Error(String(_t8)), {
                          component: "ChatContext",
                          action: "upload_file",
                          conversationId: conversationId,
                          fileName: file.name
                        });
                      }
                      errorMsg = _t8 instanceof Error ? _t8.message : String(_t8);
                      (0, _toast.toastDismissibleError)("".concat(file.name, ": ").concat(errorMsg), {
                        duration: 10000
                      });
                    case 4:
                      _context10.p = 4;
                      pendingFileNamesRef.current.delete(file.name);
                      setLoadingFiles(function (prev) {
                        var newSet = new Set(prev);
                        newSet.delete(file.name);
                        return newSet;
                      });
                      return _context10.f(4);
                    case 5:
                      return _context10.a(2);
                  }
                }, _callee10, null, [[0, 3, 4, 5]]);
              }));
              return function (_x13) {
                return _ref18.apply(this, arguments);
              };
            }()));
          case 4:
            if (uploadedAttachments.length > 0) {
              setAttachmentFiles(function (prev) {
                var uploadedIds = new Set(uploadedAttachments.map(function (a) {
                  return a.id;
                }));
                var deduped = prev.filter(function (f) {
                  return !uploadedIds.has(f.id);
                });
                return [].concat(_toConsumableArray(deduped), uploadedAttachments);
              });
            }
            return _context11.a(2, uploadedAttachments.length);
        }
      }, _callee11);
    }));
    return function (_x12) {
      return _ref17.apply(this, arguments);
    };
  }(), [selectedConversationId, createAndSelectConversation, sendError]);
  var handleSelectSavedFile = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(fileName, fileUrl) {
      var normalizedTarget, _conversationId, newConversation, response, newAttachment, errorMsg, _t9;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.p = _context12.n) {
          case 0:
            if ((0, _file.isAllowedAttachmentExtension)(fileName)) {
              _context12.n = 1;
              break;
            }
            (0, _toast.toastDismissibleError)("".concat(fileName, ": Unsupported file type. Allowed types: ").concat(_file.ALLOWED_ATTACHMENT_EXTENSIONS_LABEL, "."), {
              duration: 10000
            });
            return _context12.a(2);
          case 1:
            normalizedTarget = (0, _file.normalizeFileName)(fileName);
            if (!(attachmentFilesRef.current.some(function (f) {
              return (0, _file.normalizeFileName)(f.fileName) === normalizedTarget;
            }) || Array.from(loadingFilesRef.current).some(function (f) {
              return (0, _file.normalizeFileName)(f) === normalizedTarget;
            }) || Array.from(pendingFileNamesRef.current).some(function (f) {
              return (0, _file.normalizeFileName)(f) === normalizedTarget;
            }))) {
              _context12.n = 2;
              break;
            }
            (0, _toast.toastWarning)("Already attached: ".concat(fileName));
            return _context12.a(2);
          case 2:
            pendingFileNamesRef.current.add(fileName);
            setLoadingFiles(function (prev) {
              return new Set(prev).add(fileName);
            });
            _context12.p = 3;
            _conversationId = selectedConversationId;
            if (_conversationId) {
              _context12.n = 5;
              break;
            }
            _context12.n = 4;
            return createAndSelectConversation("New Conversation");
          case 4:
            newConversation = _context12.v;
            _conversationId = newConversation.id;
          case 5:
            _context12.n = 6;
            return (0, _webApi.createConversationFile)({
              dioptraFetch: dioptraFetch,
              conversationId: _conversationId,
              fileName: fileName,
              fileUrl: fileUrl,
              inFocus: false
            });
          case 6:
            response = _context12.v;
            newAttachment = {
              id: response.attachment.id,
              fileName: response.attachment.fileName || fileName,
              inFocus: false,
              conversationId: _conversationId,
              tokenCount: response.attachment.tokenCount,
              storageUrl: response.attachment.storageUrl
            };
            setAttachmentFiles(function (prev) {
              var deduped = prev.filter(function (f) {
                return f.id !== newAttachment.id;
              });
              return [].concat(_toConsumableArray(deduped), [newAttachment]);
            });
            _context12.n = 8;
            break;
          case 7:
            _context12.p = 7;
            _t9 = _context12.v;
            sendError(_t9 instanceof Error ? _t9 : new Error(String(_t9)), {
              component: 'ChatContext',
              action: 'select_saved_file',
              conversationId: selectedConversationId
            });
            errorMsg = _t9 instanceof Error ? _t9.message : String(_t9);
            (0, _toast.toastDismissibleError)("".concat(fileName, ": ").concat(errorMsg), {
              duration: 10000
            });
          case 8:
            _context12.p = 8;
            pendingFileNamesRef.current.delete(fileName);
            setLoadingFiles(function (prev) {
              var newSet = new Set(prev);
              newSet.delete(fileName);
              return newSet;
            });
            return _context12.f(8);
          case 9:
            return _context12.a(2);
        }
      }, _callee12, null, [[3, 7, 8, 9]]);
    }));
    return function (_x14, _x15) {
      return _ref19.apply(this, arguments);
    };
  }(), [selectedConversationId, createAndSelectConversation, sendError]);
  var attachPromptFilesToConversation = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(promptId) {
      var conversationId, promptFiles, newConversation, _t0;
      return _regenerator().w(function (_context13) {
        while (1) switch (_context13.p = _context13.n) {
          case 0:
            conversationId = selectedConversationId;
            _context13.p = 1;
            if (conversationId) {
              _context13.n = 5;
              break;
            }
            _context13.n = 2;
            return (0, _webApi.getPromptAttachments)(authHeaderRef.current, promptId);
          case 2:
            promptFiles = _context13.v;
            if (!(promptFiles.length === 0)) {
              _context13.n = 3;
              break;
            }
            return _context13.a(2);
          case 3:
            _context13.n = 4;
            return createAndSelectConversation("New Conversation");
          case 4:
            newConversation = _context13.v;
            conversationId = newConversation.id;
          case 5:
            _context13.n = 6;
            return (0, _webApi.attachPromptFiles)({
              dioptraFetch: dioptraFetch,
              conversationId: conversationId,
              promptId: promptId
            });
          case 6:
            _context13.n = 8;
            break;
          case 7:
            _context13.p = 7;
            _t0 = _context13.v;
            sendError(_t0 instanceof Error ? _t0 : new Error(String(_t0)), {
              component: "ChatContext",
              action: "attach_prompt_files",
              conversationId: conversationId
            });
            (0, _toast.toastWarning)("Couldn't attach the prompt's files");
          case 8:
            return _context13.a(2);
        }
      }, _callee13, null, [[1, 7]]);
    }));
    return function (_x16) {
      return _ref20.apply(this, arguments);
    };
  }(), [selectedConversationId, createAndSelectConversation, sendError]);
  var handleRemoveFilesClick = (0, _react.useCallback)(function (index) {
    var file = attachmentFilesRef.current[index];
    if (!file) return;
    setFileToDelete({
      id: file.id,
      fileName: file.fileName
    });
  }, []);
  var handleDeleteFileConfirm = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
    var id, fileToRemove, _t1;
    return _regenerator().w(function (_context14) {
      while (1) switch (_context14.p = _context14.n) {
        case 0:
          if (fileToDelete) {
            _context14.n = 1;
            break;
          }
          return _context14.a(2);
        case 1:
          id = fileToDelete.id;
          setFileToDelete(null);
          fileToRemove = attachmentFilesRef.current.find(function (f) {
            return f.id === id;
          });
          if (fileToRemove) {
            _context14.n = 2;
            break;
          }
          return _context14.a(2);
        case 2:
          _context14.p = 2;
          _context14.n = 3;
          return (0, _webApi.deleteConversationFile)(dioptraFetch, fileToRemove.id);
        case 3:
          setAttachmentFiles(function (prev) {
            return prev.filter(function (f) {
              return f.id !== fileToRemove.id;
            });
          });
          _context14.n = 5;
          break;
        case 4:
          _context14.p = 4;
          _t1 = _context14.v;
          sendError(_t1 instanceof Error ? _t1 : new Error(String(_t1)), {
            component: 'ChatContext',
            action: 'remove_file',
            fileId: fileToRemove.id
          });
          throw _t1;
        case 5:
          return _context14.a(2);
      }
    }, _callee14, null, [[2, 4]]);
  })), [fileToDelete, sendError]);
  var handleRemoveSavedFile = (0, _react.useCallback)(function (fileName) {
    var attachmentIndex = attachmentFilesRef.current.findIndex(function (file) {
      return (0, _file.normalizeFileName)(file.fileName) === (0, _file.normalizeFileName)(fileName);
    });
    if (attachmentIndex !== -1) {
      handleRemoveFilesClick(attachmentIndex);
    }
  }, [handleRemoveFilesClick]);
  var renameConversation = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref22 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(conversationId, newName) {
      var _t10;
      return _regenerator().w(function (_context15) {
        while (1) switch (_context15.p = _context15.n) {
          case 0:
            _context15.p = 0;
            _context15.n = 1;
            return dioptraFetch("".concat((0, _envManager.getEnv)("WEBAPP_API_BASE_URL"), "/api/chat/conversation/").concat(conversationId), {
              method: "PATCH",
              body: JSON.stringify({
                name: newName
              })
            });
          case 1:
            setSelectedConversation(function (prev) {
              return prev && prev.id === conversationId ? _objectSpread(_objectSpread({}, prev), {}, {
                name: newName
              }) : prev;
            });
            return _context15.a(2, true);
          case 2:
            _context15.p = 2;
            _t10 = _context15.v;
            console.error("Failed to rename conversation:", _t10);
            sendError(_t10, {
              component: "ChatContext",
              action: "rename_conversation",
              conversationId: conversationId
            });
            return _context15.a(2, false);
        }
      }, _callee15, null, [[0, 2]]);
    }));
    return function (_x17, _x18) {
      return _ref22.apply(this, arguments);
    };
  }(), [sendError]);
  var appendMessage = (0, _react.useCallback)(function (message) {
    setMessagesHistory(function (prev) {
      return [].concat(_toConsumableArray(prev), [message]);
    });
  }, []);
  var updateMessageById = (0, _react.useCallback)(function (messageId, updates) {
    setMessagesHistory(function (prev) {
      return prev.map(function (m) {
        return m.id === messageId ? _objectSpread(_objectSpread({}, m), updates) : m;
      });
    });
  }, []);
  var mergeMessageTurnArtifacts = (0, _react.useCallback)(function (messageId, artifacts) {
    setMessagesHistory(function (prev) {
      return prev.map(function (m) {
        return m.id === messageId ? _objectSpread(_objectSpread({}, m), {}, {
          turnArtifacts: _objectSpread(_objectSpread({}, m.turnArtifacts), artifacts)
        }) : m;
      });
    });
  }, []);
  var completeStreamingMessage = (0, _react.useCallback)(function () {
    setStreamingMessageId(undefined);
  }, []);
  var clearStreamingConversation = (0, _react.useCallback)(function () {
    userStopRequestedRef.current = streamingConversationId;
    setStreamingConversationId(undefined);
  }, [streamingConversationId]);
  var startStreamingMessage = (0, _react.useCallback)(function (message) {
    if (!selectedConversationId) {
      throw new Error("Cannot start streaming message without a selected conversation");
    }

    // Prevent multiple concurrent streaming starts from clobbering streamingMessageId
    if (streamingMessageId) {
      console.warn("Attempted to start streaming message while another is already streaming. Completing previous stream first.");
      completeStreamingMessage();
    }
    setStreamingMessageId(message.id);
    setMessagesHistory(function (prev) {
      return [].concat(_toConsumableArray(prev), [message]);
    });
    return message.id;
  }, [selectedConversationId, streamingMessageId, completeStreamingMessage]);
  var updateStreamingMessage = (0, _react.useCallback)(function (content, updates) {
    if (!streamingMessageId) return;
    setMessagesHistory(function (prev) {
      return prev.map(function (m) {
        if (m.id === streamingMessageId) {
          // Apply updates first, then append content to prevent updates.content from overriding appended content
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          var _ref23 = updates || {},
            _ = _ref23.content,
            updatesTurnArtifacts = _ref23.turnArtifacts,
            updatesWithoutContentAndArtifacts = _objectWithoutProperties(_ref23, _excluded);

          // Deep-merge turnArtifacts to preserve existing fields like type, tool_name, tool_call_id
          var nextArtifacts = _objectSpread(_objectSpread({}, m.turnArtifacts || {}), updatesTurnArtifacts || {});
          var nextContent = m.content + content;
          return _objectSpread(_objectSpread(_objectSpread({}, m), updatesWithoutContentAndArtifacts), {}, {
            turnArtifacts: nextArtifacts,
            content: nextContent
          });
        }
        return m;
      });
    });
  }, [streamingMessageId]);
  var completeCollapsibleToolResult = (0, _react.useCallback)(function (toolName, id) {
    if (!_tools.COLLAPSIBLE_TOOLS.has(toolName)) return;
    setStreamingToolResults(function (prev) {
      var newSet = new Set(prev);
      newSet.delete(id);
      return newSet;
    });
  }, []);

  // Set by the stream_retry handler so the next streamed token REPLACES the
  // "Reconciling…" placeholder in the live bubble instead of appending — the
  // retry's regenerated answer overwrites it in place (no blank, no dup).
  var replaceNextStreamingTextRef = (0, _react.useRef)(false);
  var updateLastAssistantMessage = (0, _react.useCallback)(function (content) {
    var messageType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "text";
    var turnId = arguments.length > 2 ? arguments[2] : undefined;
    var timestamp = arguments.length > 3 ? arguments[3] : undefined;
    if (!content || typeof content !== "string") {
      return;
    }
    // Read + clear outside the updater: setStreamingMessage updaters can run twice
    // under StrictMode, which would consume the one-shot flag on the first pass.
    var replace = replaceNextStreamingTextRef.current;
    replaceNextStreamingTextRef.current = false;
    var opensBubble = (0, _chatStreamReduction.opensAssistantBubble)(content);
    setStreamingMessage(function (prev) {
      if (!prev || (0, _chat.isThinking)(prev)) {
        if (!opensBubble) return prev;
        return {
          turnType: "assistant",
          content: content,
          turnArtifacts: _objectSpread({
            type: messageType
          }, timestamp ? {
            timestamp: timestamp
          } : {}),
          id: turnId,
          timestamp: timestamp
        };
      }
      var prevMessageType = (0, _chat.getMessageType)(prev);
      if (prevMessageType !== messageType) {
        var _prev$turnArtifacts;
        if (!opensBubble) return prev;
        if (((_prev$turnArtifacts = prev.turnArtifacts) === null || _prev$turnArtifacts === void 0 ? void 0 : _prev$turnArtifacts.type) !== "status" && !prev.isTransient && selectedConversationId) {
          appendMessage({
            turnType: prev.turnType,
            content: prev.content,
            turnArtifacts: prev.turnArtifacts || {},
            conversationId: selectedConversationId,
            id: prev.id,
            timestamp: prev.timestamp
          });
        }
        return {
          turnType: "assistant",
          content: content,
          turnArtifacts: _objectSpread({
            type: messageType
          }, timestamp ? {
            timestamp: timestamp
          } : {}),
          id: turnId,
          timestamp: timestamp
        };
      }
      var nextTimestamp = timestamp !== null && timestamp !== void 0 ? timestamp : prev.timestamp;
      return _objectSpread(_objectSpread({}, prev), {}, {
        id: turnId !== null && turnId !== void 0 ? turnId : prev.id,
        content: replace ? content : prev.content + content,
        timestamp: nextTimestamp,
        turnArtifacts: _objectSpread(_objectSpread({}, prev.turnArtifacts), {}, {
          type: messageType
        }, nextTimestamp ? {
          timestamp: nextTimestamp
        } : {}),
        // Once real streamed text lands, the "Reconciling…" placeholder is no
        // longer transient — clear the flag so it persists like any answer.
        isTransient: false
      });
    });
  }, [selectedConversationId, appendMessage]);
  var addToolCallMessage = (0, _react.useCallback)(function (toolName, toolCallId, expectedConversationId, turnId, timestamp) {
    if (expectedConversationId && selectedConversationIdRef.current !== expectedConversationId) {
      return;
    }
    setStreamingMessage(function (currentStreamingMessage) {
      var _currentStreamingMess;
      if (currentStreamingMessage && !(0, _chat.isThinking)(currentStreamingMessage) && ((_currentStreamingMess = currentStreamingMessage.turnArtifacts) === null || _currentStreamingMess === void 0 ? void 0 : _currentStreamingMess.type) !== "status" && !currentStreamingMessage.isTransient) {
        appendMessage({
          turnType: currentStreamingMessage.turnType,
          content: currentStreamingMessage.content,
          turnArtifacts: currentStreamingMessage.turnArtifacts || {},
          conversationId: selectedConversationId,
          id: currentStreamingMessage.id
        });
      }
      return null;
    });

    // Seed the status map so the ToolCallGroup row can render an "in_progress"
    // spinner immediately, even before the first tool_result chunk arrives.
    if (toolCallId) {
      recordToolStreamEvent({
        type: "tool_call",
        tool_call_id: toolCallId,
        tool_name: toolName
      });
    }
    appendMessage({
      turnType: "assistant",
      content: (0, _tools.getToolDisplayName)(toolName),
      turnArtifacts: _objectSpread(_objectSpread({
        type: "tool_call",
        tool_name: toolName
      }, toolCallId ? {
        tool_call_id: toolCallId
      } : {}), timestamp ? {
        timestamp: timestamp
      } : {}),
      conversationId: selectedConversationId
    });
  }, [selectedConversationId, appendMessage, recordToolStreamEvent]);
  var addStatusMessage = (0, _react.useCallback)(function (statusText, toolName) {
    var displayText = toolName ? "".concat(statusText, " (").concat(toolName, ")") : statusText;
    setStreamingMessage(function (prev) {
      var _prev$turnArtifacts2;
      if (prev && !(0, _chat.isThinking)(prev) && ((_prev$turnArtifacts2 = prev.turnArtifacts) === null || _prev$turnArtifacts2 === void 0 ? void 0 : _prev$turnArtifacts2.type) !== "status" && !prev.isTransient && selectedConversationId) {
        appendMessage({
          turnType: prev.turnType,
          content: prev.content,
          turnArtifacts: prev.turnArtifacts || {},
          conversationId: selectedConversationId,
          id: prev.id,
          timestamp: prev.timestamp
        });
      }
      return {
        turnType: "assistant",
        content: displayText,
        turnArtifacts: {
          type: "status"
        },
        isTransient: true
      };
    });
  }, [selectedConversationId, appendMessage]);
  var updateLastToolResultMessage = (0, _react.useCallback)(function (toolName, content, id, timestamp, turnArtifacts, citations, bookmarks, onTodoListUpdate) {
    var toolCallId = turnArtifacts === null || turnArtifacts === void 0 ? void 0 : turnArtifacts.tool_call_id;
    // Sub-agent wrapped text events all share the parent's tool_call_id but
    // each LLM response carries its own message id (`parsed.id` here). Using
    // tool_call_id as the message id would collapse every distinct response
    // into one bubble, killing text↔tool interleaving in the mini-chat. Key
    // wrapped-text messages by the inner LLM response id instead, so chunks
    // of the same response merge but distinct responses stay separate.
    var isWrappedText = (turnArtifacts === null || turnArtifacts === void 0 ? void 0 : turnArtifacts.wrapped_type) === "text";
    var toolId = isWrappedText ? id || "wrapped-text-".concat(Date.now()) : toolCallId || id || "tool-".concat(toolName, "-").concat(Date.now());
    if (toolName === "todo_list" && onTodoListUpdate) {
      try {
        var todoData = JSON.parse(content);
        onTodoListUpdate(todoData, toolId);
      } catch (error) {
        console.error("Failed to parse todo data:", error);
      }
    }
    if (toolCallId) {
      setToolCallIdToToolId(function (prev) {
        var newMap = new Map(prev);
        newMap.set(toolCallId, toolId);
        return newMap;
      });
      setToolCallIdToToolName(function (prev) {
        var newMap = new Map(prev);
        newMap.set(toolCallId, toolName);
        return newMap;
      });
    }
    if (_tools.COLLAPSIBLE_TOOLS.has(toolName)) {
      setStreamingToolResults(function (prev) {
        var newSet = new Set(prev);
        newSet.add(toolId);
        return newSet;
      });
    }
    if (toolCallId) {
      setMessagesHistory(function (prev) {
        var _prev$matchIdx;
        var matchIdx = -1;
        for (var i = prev.length - 1; i >= 0; i--) {
          var _m$turnArtifacts, _m$turnArtifacts2;
          var m = prev[i];
          if (m.turnType !== "assistant") continue;
          if (((_m$turnArtifacts = m.turnArtifacts) === null || _m$turnArtifacts === void 0 ? void 0 : _m$turnArtifacts.type) !== "tool_result") continue;
          if (((_m$turnArtifacts2 = m.turnArtifacts) === null || _m$turnArtifacts2 === void 0 ? void 0 : _m$turnArtifacts2.tool_call_id) !== toolCallId) continue;
          if (isWrappedText && m.id !== id) continue;
          matchIdx = i;
          break;
        }
        var mergedArtifacts = _objectSpread(_objectSpread(_objectSpread({}, ((_prev$matchIdx = prev[matchIdx]) === null || _prev$matchIdx === void 0 ? void 0 : _prev$matchIdx.turnArtifacts) || {}), turnArtifacts || {}), {}, {
          tool_call_id: toolCallId,
          type: "tool_result",
          tool_name: toolName,
          streaming: (turnArtifacts === null || turnArtifacts === void 0 ? void 0 : turnArtifacts.streaming) === true
        });
        if (matchIdx >= 0) {
          var _existing$turnArtifac;
          var existing = prev[matchIdx];
          var merged = (0, _chatStreamReduction.mergeStreamedToolResult)({
            content: existing.content || "",
            streaming: (_existing$turnArtifac = existing.turnArtifacts) === null || _existing$turnArtifac === void 0 ? void 0 : _existing$turnArtifac.streaming
          }, {
            content: content,
            streaming: turnArtifacts === null || turnArtifacts === void 0 ? void 0 : turnArtifacts.streaming,
            replacesPrevious: _chat.REPLACE_MODE_TOOLS.has(toolName)
          });
          var nextContent = merged.content;
          var updated = _objectSpread(_objectSpread({}, existing), {}, {
            content: nextContent,
            timestamp: timestamp || existing.timestamp,
            turnArtifacts: mergedArtifacts,
            citations: citations || existing.citations,
            bookmarks: bookmarks || existing.bookmarks
          });
          return [].concat(_toConsumableArray(prev.slice(0, matchIdx)), [updated], _toConsumableArray(prev.slice(matchIdx + 1)));
        }
        var newMsg = {
          turnType: "assistant",
          content: content,
          messageType: "tool_result",
          toolName: toolName,
          id: toolId,
          timestamp: timestamp,
          turnArtifacts: mergedArtifacts,
          conversationId: selectedConversationId,
          citations: citations,
          bookmarks: bookmarks
        };
        return [].concat(_toConsumableArray(prev), [newMsg]);
      });
      return;
    }
    setStreamingMessage(function (prev) {
      var _prev$turnArtifacts3, _prev$turnArtifacts4;
      var prevIsToolResult = (prev === null || prev === void 0 ? void 0 : prev.messageType) === "tool_result";
      var prevId = prev === null || prev === void 0 ? void 0 : prev.id;
      var isSameToolCall = prevIsToolResult && ((prev === null || prev === void 0 ? void 0 : prev.toolName) || (prev === null || prev === void 0 || (_prev$turnArtifacts3 = prev.turnArtifacts) === null || _prev$turnArtifacts3 === void 0 ? void 0 : _prev$turnArtifacts3.tool_name)) === toolName && prevId && prevId === toolId;
      var shouldFlushPrevious = !!selectedConversationId && prev && !(0, _chat.isThinking)(prev) && ((_prev$turnArtifacts4 = prev.turnArtifacts) === null || _prev$turnArtifacts4 === void 0 ? void 0 : _prev$turnArtifacts4.type) !== "status" && prevIsToolResult && !isSameToolCall;
      if (shouldFlushPrevious && selectedConversationId) {
        appendMessage({
          turnType: prev.turnType,
          content: prev.content,
          turnArtifacts: prev.turnArtifacts || {},
          conversationId: selectedConversationId,
          id: prev.id,
          timestamp: prev.timestamp
        });
      }
      var mergedArtifacts = _objectSpread(_objectSpread(_objectSpread({}, isSameToolCall ? (prev === null || prev === void 0 ? void 0 : prev.turnArtifacts) || {} : {}), turnArtifacts || {}), {}, {
        type: "tool_result",
        tool_name: toolName
      });
      if (prev && isSameToolCall) {
        var _prev$turnArtifacts5;
        var nextContent = (0, _chatStreamReduction.mergeStreamedToolResult)({
          content: prev.content,
          streaming: (_prev$turnArtifacts5 = prev.turnArtifacts) === null || _prev$turnArtifacts5 === void 0 ? void 0 : _prev$turnArtifacts5.streaming
        }, {
          content: content,
          streaming: turnArtifacts === null || turnArtifacts === void 0 ? void 0 : turnArtifacts.streaming,
          replacesPrevious: _chat.REPLACE_MODE_TOOLS.has(toolName)
        }).content;
        return _objectSpread(_objectSpread({}, prev), {}, {
          content: nextContent,
          timestamp: timestamp || prev.timestamp,
          turnArtifacts: mergedArtifacts,
          citations: citations || prev.citations,
          bookmarks: bookmarks || prev.bookmarks
        });
      }
      return {
        turnType: "assistant",
        content: content,
        messageType: "tool_result",
        toolName: toolName,
        id: toolId,
        timestamp: timestamp,
        turnArtifacts: mergedArtifacts,
        citations: citations,
        bookmarks: bookmarks
      };
    });
  }, [selectedConversationId, appendMessage]);
  var handleAutoRename = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref24 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(userMessage) {
      var conversation, response, currentConversation, _t11;
      return _regenerator().w(function (_context16) {
        while (1) switch (_context16.p = _context16.n) {
          case 0:
            if (!(!selectedConversationId || !(userMessage !== null && userMessage !== void 0 && userMessage.trim()))) {
              _context16.n = 1;
              break;
            }
            return _context16.a(2);
          case 1:
            conversation = selectedConversationRef.current;
            if (!(!conversation || conversation.id !== selectedConversationId || conversation.name !== "New Conversation")) {
              _context16.n = 2;
              break;
            }
            return _context16.a(2);
          case 2:
            _context16.p = 2;
            _context16.n = 3;
            return dioptraFetch("".concat((0, _envManager.getEnv)("WEBAPP_API_BASE_URL"), "/api/chat/conversation/suggest-name"), {
              method: "POST",
              body: JSON.stringify({
                message: userMessage
              })
            });
          case 3:
            response = _context16.v;
            currentConversation = selectedConversationRef.current;
            if (!((currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.id) === selectedConversationId && currentConversation.name === "New Conversation" && response !== null && response !== void 0 && response.name && response.name !== "New Conversation")) {
              _context16.n = 4;
              break;
            }
            _context16.n = 4;
            return renameConversation(selectedConversationId, response.name);
          case 4:
            _context16.n = 6;
            break;
          case 5:
            _context16.p = 5;
            _t11 = _context16.v;
            console.warn("Auto-rename failed:", _t11);
          case 6:
            return _context16.a(2);
        }
      }, _callee16, null, [[2, 5]]);
    }));
    return function (_x19) {
      return _ref24.apply(this, arguments);
    };
  }(), [renameConversation, selectedConversationId]);
  var handleStreamRetry = (0, _react.useCallback)(function () {
    // The backend regenerates the whole assistant turn on retry (rollback_partial_turns
    // on its side). Drop any partial turns already committed to messagesHistory — a
    // periodic status/tool_call event can flush partial text there mid-stream — so the
    // re-stream doesn't duplicate against them.
    setMessagesHistory(function (prev) {
      return (0, _streamRetry.keepTurnsThroughLastUserTurn)(prev, function (message) {
        return message.turnType;
      });
    });
    // Keep a visible "Reconciling…" bubble in the live slot — a normal text bubble so
    // it renders in the same spot as the answer — rather than clearing it to blank.
    // The flag makes the retry's first token replace it in place (see
    // replaceNextStreamingTextRef in updateLastAssistantMessage) — no blank, no dup.
    setStreamingMessage({
      turnType: "assistant",
      content: _streamRetry.RECONCILING_PLACEHOLDER_TEXT,
      turnArtifacts: {
        type: "text"
      },
      isTransient: true
    });
    replaceNextStreamingTextRef.current = true;
  }, []);
  var handleAddinContentRequest = (0, _react.useCallback)(function (requestId, requester) {
    if (!requestId) {
      console.warn("addin_content_request received without request_id, ignoring");
      return;
    }
    (0, _contentRequestFulfillment.fulfillDocumentContentRequest)(requestId, {
      dioptraFetch: dioptraFetch,
      sendError: sendError
    }).then(function (outcome) {
      if (outcome.kind !== "uploaded" || requester.kind !== "conversation_agent") return;
      _anchorTrackerRegistry.officeWordDocument.events.publishDocumentSentToAgent({
        conversationId: requester.conversationId,
        coversEventsThroughSequence: outcome.coversEventsThroughSequence
      });
    }).catch(function (err) {
      return sendError(err instanceof Error ? err : new Error(String(err)), {
        component: "ChatContext",
        action: "fulfill_addin_content_request"
      });
    });
  }, [dioptraFetch, sendError]);
  var handleJsExecutionRequest = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref26 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(_ref25) {
      var requestId, code, agentRole, toolCallId, turnId, requestedAt, scriptOrigin, rejectReason, checkpointTarget, onScriptFinished, answerTimeline, answerJsExecutionRequest, logs, returnValue, error, scriptError, runScript, stdout, _t12, _t13;
      return _regenerator().w(function (_context19) {
        while (1) switch (_context19.p = _context19.n) {
          case 0:
            answerJsExecutionRequest = function _answerJsExecutionReq(responsePayload) {
              answerTimeline.enterStep("fulfill_post");
              return answerTimeline.settleWhen((0, _contentRequestFulfillment.fulfillJsExecutionRequest)(requestId, responsePayload, {
                dioptraFetch: dioptraFetch,
                sendError: sendError
              }));
            };
            requestId = _ref25.requestId, code = _ref25.code, agentRole = _ref25.agentRole, toolCallId = _ref25.toolCallId, turnId = _ref25.turnId, requestedAt = _ref25.requestedAt, scriptOrigin = _ref25.scriptOrigin, rejectReason = _ref25.rejectReason, checkpointTarget = _ref25.checkpointTarget, onScriptFinished = _ref25.onScriptFinished;
            if (!(!requestId || !code)) {
              _context19.n = 1;
              break;
            }
            console.warn("addin_content_request js_execution received without request_id or code, ignoring");
            return _context19.a(2);
          case 1:
            answerTimeline = new _addinRequestAnswerTimeline.AddinRequestAnswerTimeline("js_execution", requestId);
            if (!rejectReason) {
              _context19.n = 3;
              break;
            }
            _context19.n = 2;
            return answerJsExecutionRequest({
              stdout: "",
              return_value: null,
              error: rejectReason,
              success: false
            }).catch(function (err) {
              return sendError(err instanceof Error ? err : new Error(String(err)), {
                component: "ChatContext",
                action: "reject_js_execution_request"
              });
            });
          case 2:
            return _context19.a(2);
          case 3:
            logs = [];
            returnValue = null;
            error = null;
            scriptError = null;
            _context19.p = 4;
            runScript = (0, _executeJsScript.compileAgentScript)(code);
            _context19.n = 5;
            return (0, _executeJsScript.runScriptWithinDeadline)(/*#__PURE__*/function () {
              var _ref27 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(deadline) {
                return _regenerator().w(function (_context18) {
                  while (1) switch (_context18.n) {
                    case 0:
                      answerTimeline.enterStep("document_checkpoint");
                      _context18.n = 1;
                      return captureDocumentCheckpoint({
                        trigger: "execute_js",
                        target: checkpointTarget,
                        toolCallId: toolCallId !== null && toolCallId !== void 0 ? toolCallId : null,
                        turnId: turnId !== null && turnId !== void 0 ? turnId : null,
                        capturedAt: requestedAt
                      });
                    case 1:
                      answerTimeline.enterStep("write_lock_wait");
                      _context18.n = 2;
                      return (0, _document.withWordContextWrite)(/*#__PURE__*/function () {
                        var _ref28 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(context) {
                          var result;
                          return _regenerator().w(function (_context17) {
                            while (1) switch (_context17.n) {
                              case 0:
                                if (!deadline.aborted) {
                                  _context17.n = 1;
                                  break;
                                }
                                return _context17.a(2);
                              case 1:
                                answerTimeline.enterStep("run_script");
                                context.document.changeTrackingMode = Word.ChangeTrackingMode.trackAll;
                                _context17.n = 2;
                                return context.sync();
                              case 2:
                                if (!deadline.aborted) {
                                  _context17.n = 3;
                                  break;
                                }
                                return _context17.a(2);
                              case 3:
                                _context17.n = 4;
                                return runScript(Word, context, logs);
                              case 4:
                                result = _context17.v;
                                if (result !== undefined) returnValue = String(result);
                              case 5:
                                return _context17.a(2);
                            }
                          }, _callee17);
                        }));
                        return function (_x22) {
                          return _ref28.apply(this, arguments);
                        };
                      }());
                    case 2:
                      return _context18.a(2);
                  }
                }, _callee18);
              }));
              return function (_x21) {
                return _ref27.apply(this, arguments);
              };
            }());
          case 5:
            _context19.n = 7;
            break;
          case 6:
            _context19.p = 6;
            _t12 = _context19.v;
            scriptError = _t12 instanceof Error ? _t12 : new Error(String(_t12));
            error = (0, _executeJsScript.describeScriptError)(scriptError);
          case 7:
            stdout = logs.join("\n");
            if (!onScriptFinished) {
              _context19.n = 11;
              break;
            }
            answerTimeline.enterStep("script_finished_observer");
            _context19.p = 8;
            _context19.n = 9;
            return onScriptFinished();
          case 9:
            _context19.n = 11;
            break;
          case 10:
            _context19.p = 10;
            _t13 = _context19.v;
            sendError(_t13 instanceof Error ? _t13 : new Error(String(_t13)), {
              component: "ChatContext",
              action: "js_execution_observer"
            });
          case 11:
            _context19.n = 12;
            return answerJsExecutionRequest({
              stdout: stdout,
              return_value: returnValue,
              error: error,
              success: error === null
            }).catch(function (err) {
              return sendError(err instanceof Error ? err : new Error(String(err)), {
                component: "ChatContext",
                action: "fulfill_js_execution_request"
              });
            });
          case 12:
            if (!(scriptOrigin === "agent_chat")) {
              _context19.n = 13;
              break;
            }
            _context19.n = 13;
            return (0, _executeJsRedlineReport.reportAgentScriptOutcome)({
              script: code,
              stdout: stdout,
              error: scriptError,
              agentRole: agentRole
            });
          case 13:
            return _context19.a(2);
        }
      }, _callee19, null, [[8, 10], [4, 6]]);
    }));
    return function (_x20) {
      return _ref26.apply(this, arguments);
    };
  }(), [dioptraFetch, sendError, captureDocumentCheckpoint]);

  // How long the red dot "glows" (pulses) after appearing, before settling
  // into a steady solid dot. Matches the UX in the files panel + plus button.
  var ARTIFACT_FLASH_MS = 3000;

  // Starts (or restarts) the 3s glow animation for `artifactId`. When the
  // glow finishes the artifact is considered "seen" and its red dot is
  // removed — it will only reappear if another `artifact_updated` event
  // arrives for the same id.
  var flashArtifact = (0, _react.useCallback)(function (artifactId) {
    var existing = artifactFlashTimersRef.current.get(artifactId);
    if (existing) clearTimeout(existing);
    setFlashingArtifactIds(function (prev) {
      var next = new Set(prev);
      next.add(artifactId);
      return next;
    });
    var handle = setTimeout(function () {
      artifactFlashTimersRef.current.delete(artifactId);
      setFlashingArtifactIds(function (prev) {
        if (!prev.has(artifactId)) return prev;
        var next = new Set(prev);
        next.delete(artifactId);
        return next;
      });
      setRecentArtifactIds(function (prev) {
        if (!prev.has(artifactId)) return prev;
        var next = new Set(prev);
        next.delete(artifactId);
        return next;
      });
    }, ARTIFACT_FLASH_MS);
    artifactFlashTimersRef.current.set(artifactId, handle);
  }, []);

  // Called when the user explicitly clicks an artifact row. Cancels any
  // pending glow and clears the red dot immediately.
  var markArtifactSeen = (0, _react.useCallback)(function (artifactId) {
    var existing = artifactFlashTimersRef.current.get(artifactId);
    if (existing) {
      clearTimeout(existing);
      artifactFlashTimersRef.current.delete(artifactId);
    }
    setFlashingArtifactIds(function (prev) {
      if (!prev.has(artifactId)) return prev;
      var next = new Set(prev);
      next.delete(artifactId);
      return next;
    });
    setRecentArtifactIds(function (prev) {
      if (!prev.has(artifactId)) return prev;
      var next = new Set(prev);
      next.delete(artifactId);
      return next;
    });
  }, []);
  var handleArtifactUpdated = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref29 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(artifactId) {
      var fresh, _t14;
      return _regenerator().w(function (_context20) {
        while (1) switch (_context20.p = _context20.n) {
          case 0:
            void announceResourceChanged((0, _artifactResource.artifactResource)(artifactId));
            _context20.p = 1;
            _context20.n = 2;
            return (0, _webApi.getConversationArtifacts)(dioptraFetch, selectedConversationIdRef.current || "");
          case 2:
            fresh = _context20.v;
            setArtifacts(fresh);
            _context20.n = 4;
            break;
          case 3:
            _context20.p = 3;
            _t14 = _context20.v;
            sendError(_t14 instanceof Error ? _t14 : new Error(String(_t14)), {
              component: "ChatContext",
              action: "refresh_artifacts_on_update",
              artifactId: artifactId
            });
          case 4:
            setRecentArtifactIds(function (prev) {
              var next = new Set(prev);
              next.add(artifactId);
              return next;
            });
            if (filesPanelOpenRef.current) {
              flashArtifact(artifactId);
            } else {
              setPlusButtonHasArtifactDot(true);
              setChatArtifactsMenuItemHasArtifactDot(true);
              setPlusButtonArtifactDotFlashing(true);
              setTimeout(function () {
                return setPlusButtonArtifactDotFlashing(false);
              }, ARTIFACT_FLASH_MS);
            }
          case 5:
            return _context20.a(2);
        }
      }, _callee20, null, [[1, 3]]);
    }));
    return function (_x23) {
      return _ref29.apply(this, arguments);
    };
  }(), [dioptraFetch, flashArtifact, sendError, announceResourceChanged]);

  // Remove an artifact optimistically and reconcile the local "unread" /
  // "flashing" sets so we don't leave a red dot floating for a deleted id.
  // On failure we restore the row; the backend route (Next.js CRUD) also
  // drops the backing storage file, so there's nothing else to clean up
  // client-side.
  var handleDeleteArtifact = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref30 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(artifact) {
      var previous, _t15;
      return _regenerator().w(function (_context21) {
        while (1) switch (_context21.p = _context21.n) {
          case 0:
            previous = [];
            setArtifacts(function (prev) {
              previous = prev;
              return prev.filter(function (a) {
                return a.id !== artifact.id;
              });
            });
            setRecentArtifactIds(function (prev) {
              if (!prev.has(artifact.id)) return prev;
              var next = new Set(prev);
              next.delete(artifact.id);
              return next;
            });
            setFlashingArtifactIds(function (prev) {
              if (!prev.has(artifact.id)) return prev;
              var next = new Set(prev);
              next.delete(artifact.id);
              return next;
            });
            _context21.p = 1;
            _context21.n = 2;
            return (0, _webApi.deleteConversationArtifact)(dioptraFetch, artifact.id);
          case 2:
            void announceResourceChanged((0, _artifactResource.artifactResource)(artifact.id));
            _context21.n = 4;
            break;
          case 3:
            _context21.p = 3;
            _t15 = _context21.v;
            setArtifacts(previous);
            sendError(_t15 instanceof Error ? _t15 : new Error(String(_t15)), {
              component: "ChatContext",
              action: "delete_artifact",
              artifactId: artifact.id
            });
            throw _t15;
          case 4:
            return _context21.a(2);
        }
      }, _callee21, null, [[1, 3]]);
    }));
    return function (_x24) {
      return _ref30.apply(this, arguments);
    };
  }(), [dioptraFetch, sendError, announceResourceChanged]);
  var handlePromoteArtifact = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref31 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(artifact) {
      var previous, _t16;
      return _regenerator().w(function (_context22) {
        while (1) switch (_context22.p = _context22.n) {
          case 0:
            previous = [];
            setArtifacts(function (prev) {
              previous = prev;
              return prev.map(function (a) {
                return a.id === artifact.id ? _objectSpread(_objectSpread({}, a), {}, {
                  scope: "workspace"
                }) : a;
              });
            });
            _context22.p = 1;
            _context22.n = 2;
            return (0, _webApi.promoteConversationArtifact)(dioptraFetch, artifact.id);
          case 2:
            _context22.n = 4;
            break;
          case 3:
            _context22.p = 3;
            _t16 = _context22.v;
            setArtifacts(previous);
            sendError(_t16 instanceof Error ? _t16 : new Error(String(_t16)), {
              component: "ChatContext",
              action: "promote_artifact",
              artifactId: artifact.id
            });
            throw _t16;
          case 4:
            return _context22.a(2);
        }
      }, _callee22, null, [[1, 3]]);
    }));
    return function (_x25) {
      return _ref31.apply(this, arguments);
    };
  }(), [dioptraFetch, sendError]);
  var notifyFilesPanelOpen = (0, _react.useCallback)(function () {
    filesPanelOpenRef.current = true;
    setPlusButtonHasArtifactDot(false);
    setPlusButtonArtifactDotFlashing(false);
    setChatArtifactsMenuItemHasArtifactDot(false);
    var currentRecent = recentArtifactIdsRef.current;
    currentRecent.forEach(function (id) {
      return flashArtifact(id);
    });
  }, [flashArtifact]);
  var notifyAddMenuOpen = (0, _react.useCallback)(function () {
    setPlusButtonHasArtifactDot(false);
    setPlusButtonArtifactDotFlashing(false);
  }, []);
  var notifyFilesPanelClose = (0, _react.useCallback)(function () {
    filesPanelOpenRef.current = false;
  }, []);
  var applyStreamSideEffects = (0, _react.useCallback)(function (parsed, target) {
    var streamedAt = (0, _parseStreamedTimestamp.parseStreamedTimestamp)(parsed.timestamp);
    if (parsed.type === "tool_call" && parsed.tool_name && _tools.DOCUMENT_CHANGE_TOOL_NAMES.has(parsed.tool_name)) {
      var _parsed$tool_call_id, _parseStreamedTurnId;
      void captureDocumentCheckpoint({
        trigger: "tool-call:".concat(parsed.tool_name),
        target: target,
        toolCallId: (_parsed$tool_call_id = parsed.tool_call_id) !== null && _parsed$tool_call_id !== void 0 ? _parsed$tool_call_id : null,
        turnId: (_parseStreamedTurnId = (0, _parseStreamedTurnId2.parseStreamedTurnId)(parsed.turn_id)) !== null && _parseStreamedTurnId !== void 0 ? _parseStreamedTurnId : null,
        capturedAt: streamedAt
      });
    } else if (parsed.type === "addin_content_request" && parsed.request_type === "document") {
      handleAddinContentRequest(parsed.request_id, parsed.wrapped_type === undefined && target.conversationId ? {
        kind: "conversation_agent",
        conversationId: target.conversationId
      } : {
        kind: "another_agent"
      });
    } else if (parsed.type === "addin_content_request" && parsed.request_type === "js_execution") {
      void handleJsExecutionRequest({
        requestId: parsed.request_id,
        code: parsed.code,
        agentRole: parsed.role,
        toolCallId: parsed.tool_call_id,
        turnId: parsed.turn_id,
        requestedAt: streamedAt,
        scriptOrigin: "agent_chat",
        rejectReason: null,
        checkpointTarget: target
      });
    }
  }, [captureDocumentCheckpoint, handleAddinContentRequest, handleJsExecutionRequest]);
  var dispatchStreamEvent = (0, _react.useCallback)(function (parsed, streamingConversationId, onTodoListUpdate) {
    // Single source of truth for tool-call status snapshots. Handles seeding
    // on tool_call, the text-flushes-in_progress rule for inline-result tools,
    // and terminal flips from tool_result / tool_status events. Message-state
    // updates remain in the branches below.
    recordToolStreamEvent(parsed, parsed.text || parsed.content || "");
    var streamedAt = (0, _parseStreamedTimestamp.parseStreamedTimestamp)(parsed.timestamp);
    if (parsed.type === "text" && parsed.text) {
      var streamedTurnId = (0, _parseStreamedTurnId2.parseStreamedTurnId)(parsed.turn_id);
      if (streamedTurnId) {
        streamedTurnIdRef.current = streamedTurnId;
      }
      updateLastAssistantMessage(parsed.text, "text", streamedTurnId, streamedAt);
    } else if (parsed.type === "thinking" && parsed.text) {
      updateLastAssistantMessage(parsed.text, "thinking", undefined, streamedAt);
    } else if (parsed.type === "tool_call_args") {
      var preview = (0, _chatStreamReduction.collectInputPreviewOf)(parsed);
      if (preview) {
        updateLastToolResultMessage(preview.toolName, preview.argumentsDelta, preview.toolCallId, preview.timestamp, (0, _chatStreamReduction.collectInputPreviewArtifacts)(preview.toolCallId));
      }
    } else if (parsed.type === "tool_call" && parsed.tool_name) {
      addToolCallMessage(parsed.tool_name, parsed.tool_call_id, streamingConversationId, parsed.turn_id, streamedAt);
    } else if (parsed.type === "tool_result") {
      var redlineAuthorSides = (0, _redlineAuthorSidesEvent.redlineAuthorSidesOf)(parsed.content);
      if (redlineAuthorSides !== null) applyRedlineAuthorSides(redlineAuthorSides);
      updateLastToolResultMessage(parsed.tool_name, (0, _chatStreamReduction.toolResultContentOf)(parsed), parsed.id, parsed.timestamp, (0, _chatStreamReduction.toolResultArtifactsOf)(parsed), parsed.citations, parsed.bookmarks, onTodoListUpdate);
      if ((0, _chatStreamReduction.isWrappedInterruption)(parsed)) {
        markToolsInProgressAsInterrupted();
        setMessagesHistory(_chatStreamReduction.withoutStreamingPreviews);
      }
    } else if (parsed.type === "status" && parsed.text) {
      addStatusMessage(parsed.text, parsed.tool_name);
    } else if (parsed.type === "error") {
      updateLastAssistantMessage(parsed.text || "An error occurred", "text");
    } else if (parsed.type === "stream_retry") {
      handleStreamRetry();
    } else if (parsed.type === "artifact_updated" && parsed.artifact_id) {
      handleArtifactUpdated(parsed.artifact_id);
    } else if (parsed.type === "interrupted") {
      markToolsInProgressAsInterrupted();
      setMessagesHistory(_chatStreamReduction.withoutStreamingPreviews);
    } else if (parsed.type === _chatMessageFiles.USER_TURN_FILES_EVENT_TYPE) {
      var _UserTurnFilesEventSc = _chatMessageFiles.UserTurnFilesEventSchema.parse(parsed),
        _files = _UserTurnFilesEventSc.files;
      setMessagesHistory(function (prev) {
        return (0, _sentMessageFiles.withFilesOnLastUserMessage)(prev, _sentMessageFiles.hasUserTurnType, _files);
      });
    }
  }, [recordToolStreamEvent, updateLastAssistantMessage, addToolCallMessage, updateLastToolResultMessage, addStatusMessage, handleStreamRetry, handleArtifactUpdated, markToolsInProgressAsInterrupted, applyRedlineAuthorSides]);
  var runDatabaseCatchUpPoll = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref32 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(conversationId) {
      var selectionEpoch, runningPoll, markPollActivity, _activePollRef$curren, stillOwnsPoll, _t17;
      return _regenerator().w(function (_context23) {
        while (1) switch (_context23.p = _context23.n) {
          case 0:
            selectionEpoch = conversationSelectionEpochRef.current;
            runningPoll = activePollRef.current;
            if (!((runningPoll === null || runningPoll === void 0 ? void 0 : runningPoll.conversationId) === conversationId && runningPoll.selectionEpoch === selectionEpoch)) {
              _context23.n = 1;
              break;
            }
            return _context23.a(2);
          case 1:
            activePollRef.current = {
              conversationId: conversationId,
              selectionEpoch: selectionEpoch
            };
            setIsPolling(true);
            setPollDetectedActivity(false);
            markPollActivity = function markPollActivity() {
              if (selectedConversationIdRef.current === conversationId) {
                setPollDetectedActivity(true);
              }
            };
            _context23.p = 2;
            _context23.n = 3;
            return (0, _pollUntilStable.pollUntilStable)({
              fetchMessages: function fetchMessages() {
                return (0, _webApi.getMessagesHistory)(dioptraFetch, conversationId);
              },
              conversationId: conversationId,
              selectedConversationIdRef: selectedConversationIdRef,
              setMessages: setMessagesHistory,
              onGrowth: markPollActivity,
              keepPolling: function keepPolling(messages) {
                var hasWorkInFlight = (0, _conversationWorkInFlight.conversationHasWorkInFlight)(messages) || Array.from(conversationIdByOpenChatStreamRef.current.values()).includes(conversationId);
                if (hasWorkInFlight) markPollActivity();
                return hasWorkInFlight;
              },
              isPollCurrent: function isPollCurrent() {
                return conversationSelectionEpochRef.current === selectionEpoch;
              }
            });
          case 3:
            _context23.n = 5;
            break;
          case 4:
            _context23.p = 4;
            _t17 = _context23.v;
            sendError(_t17 instanceof Error ? _t17 : new Error(String(_t17)), {
              component: "ChatContext",
              action: "poll_message_history",
              conversationId: conversationId
            });
          case 5:
            _context23.p = 5;
            stillOwnsPoll = ((_activePollRef$curren = activePollRef.current) === null || _activePollRef$curren === void 0 ? void 0 : _activePollRef$curren.conversationId) === conversationId && activePollRef.current.selectionEpoch === selectionEpoch;
            if (stillOwnsPoll) {
              activePollRef.current = undefined;
              if (selectedConversationIdRef.current === conversationId) {
                setIsPolling(false);
                setPollDetectedActivity(false);
              }
            }
            return _context23.f(5);
          case 6:
            return _context23.a(2);
        }
      }, _callee23, null, [[2, 4, 5, 6]]);
    }));
    return function (_x26) {
      return _ref32.apply(this, arguments);
    };
  }(), [dioptraFetch, sendError]);
  var flushStreamingMessage = (0, _react.useCallback)(function () {
    setStreamingMessage(function (prev) {
      var _prev$turnArtifacts6;
      if (prev && !(0, _chat.isThinking)(prev) && ((_prev$turnArtifacts6 = prev.turnArtifacts) === null || _prev$turnArtifacts6 === void 0 ? void 0 : _prev$turnArtifacts6.type) !== "status" && !prev.isTransient && selectedConversationId) {
        appendMessage({
          turnType: prev.turnType,
          content: prev.content,
          turnArtifacts: prev.turnArtifacts || {},
          conversationId: selectedConversationId,
          id: prev.id,
          timestamp: prev.timestamp
        });
      }
      return null;
    });
  }, [selectedConversationId, appendMessage]);
  var sendMessage = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref33 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(message, options) {
      var selectedSkills, selectedModel, pendingAttachmentUpdate, onGeneratingChange, onError, onTodoListUpdate, agentOnlyContext, streamingConversationId, openChatStream, _selectionOoxmlStripp, filesSent, sentTurnArtifacts, isFirstMessage, errorMessage, focusedDocumentRead, documentChangesForMessage, chatStreamGenerator, reader, streamCompletedNormally, hasHandedOffToDatabase, streamSideEffectTarget, handleParsedStreamEvent, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, outcome, wasUserStop, error, _t18, _t19, _t20, _t21;
      return _regenerator().w(function (_context24) {
        while (1) switch (_context24.p = _context24.n) {
          case 0:
            selectedSkills = options.selectedSkills, selectedModel = options.selectedModel, pendingAttachmentUpdate = options.pendingAttachmentUpdate, onGeneratingChange = options.onGeneratingChange, onError = options.onError, onTodoListUpdate = options.onTodoListUpdate, agentOnlyContext = options.agentOnlyContext;
            streamingConversationId = selectedConversationId;
            openChatStream = Symbol("open chat stream");
            if (streamingConversationId) conversationsHandedOffToDatabaseRef.current.delete(streamingConversationId);
            userStopRequestedRef.current = undefined;
            _context24.p = 1;
            if (message.trim()) {
              _context24.n = 2;
              break;
            }
            return _context24.a(2);
          case 2:
            setStreamingConversationId(streamingConversationId);
            if (streamingConversationId) conversationIdByOpenChatStreamRef.current.set(openChatStream, streamingConversationId);
            onGeneratingChange === null || onGeneratingChange === void 0 || onGeneratingChange(true);
            filesSent = (0, _sentMessageFiles.filesSentWithNextMessage)(attachmentFilesRef.current, messagesHistory, _sentMessageFiles.hasUserTurnType);
            sentTurnArtifacts = filesSent;
            appendMessage({
              turnType: "user",
              content: message,
              conversationId: streamingConversationId,
              turnArtifacts: sentTurnArtifacts
            });
            setStreamingMessage({
              turnType: "assistant",
              content: "Thinking..."
            });
            isFirstMessage = messagesHistory.length === 0;
            if (isFirstMessage) {
              handleAutoRename(message);
            }
            if (!pendingAttachmentUpdate) {
              _context24.n = 7;
              break;
            }
            _context24.p = 3;
            _context24.n = 4;
            return pendingAttachmentUpdate;
          case 4:
            _context24.n = 7;
            break;
          case 5:
            _context24.p = 5;
            _t18 = _context24.v;
            errorMessage = _t18 instanceof Error ? _t18.message : String(_t18);
            if (errorMessage.startsWith("TIMEOUT_ERROR:")) {
              _context24.n = 6;
              break;
            }
            throw _t18;
          case 6:
            // Timeout errors are handled silently in the UI layer
            console.warn("Document attachment timed out, continuing with chat.", _t18);
          case 7:
            if (!isFirstMessage) {
              _context24.n = 9;
              break;
            }
            _context24.n = 8;
            return (0, _focusedDocumentSnapshot.readFocusedDocumentAttachment)({
              component: "ChatContext",
              action: "send_first_message",
              sendError: sendError
            });
          case 8:
            _t19 = _context24.v;
            _context24.n = 10;
            break;
          case 9:
            _t19 = undefined;
          case 10:
            focusedDocumentRead = _t19;
            documentChangesForMessage = streamingConversationId ? _anchorTrackerRegistry.agentDocumentViews.changesForMessage(streamingConversationId) : null;
            _context24.n = 11;
            return (0, _api.agentChatSimple)({
              dioptraFetchStream: dioptraFetchStream,
              message: message,
              conversationId: streamingConversationId,
              modelName: selectedModel,
              skills: selectedSkills,
              selectedTextSnippet: ((_selectionOoxmlStripp = selectionOoxmlStrippedRef.current) !== null && _selectionOoxmlStripp !== void 0 ? _selectionOoxmlStripp : selectedTextRef.current) || undefined,
              focusedDocument: focusedDocumentRead === null || focusedDocumentRead === void 0 ? void 0 : focusedDocumentRead.attachment,
              documentChanges: documentChangesForMessage === null || documentChangesForMessage === void 0 ? void 0 : documentChangesForMessage.documentChanges,
              agentInstructions: agentOnlyContext
            });
          case 11:
            chatStreamGenerator = _context24.v;
            if (focusedDocumentRead && streamingConversationId) {
              _anchorTrackerRegistry.officeWordDocument.events.publishDocumentSentToAgent({
                conversationId: streamingConversationId,
                coversEventsThroughSequence: focusedDocumentRead.coversEventsThroughSequence
              });
            }
            reader = chatStreamGenerator.getReader();
            streamCompletedNormally = false;
            streamedTurnIdRef.current = null;
            if (streamingConversationId) conversationsAwaitingResponseCheckpointRef.current.add(streamingConversationId);
            hasHandedOffToDatabase = function hasHandedOffToDatabase() {
              return !streamingConversationId || conversationsHandedOffToDatabaseRef.current.has(streamingConversationId);
            };
            streamSideEffectTarget = {
              conversationId: streamingConversationId,
              openDocumentOwnsConversation: conversationMatchesOpenDocumentRef.current
            };
            handleParsedStreamEvent = function handleParsedStreamEvent(parsed) {
              if (parsed.type === _documentChangesForAgent.DOCUMENT_CHANGES_RECEIVED_EVENT_TYPE) documentChangesForMessage === null || documentChangesForMessage === void 0 || documentChangesForMessage.markDelivered();
              applyStreamSideEffects(parsed, streamSideEffectTarget);
              if (hasHandedOffToDatabase()) return;
              dispatchStreamEvent(parsed, streamingConversationId, onTodoListUpdate);
            };
            _context24.p = 12;
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context24.p = 13;
            _iterator = _asyncIterator((0, _chatStreamReader.readNdjsonStream)(reader, {
              idleTimeoutMs: _chatStreamReader.CHAT_STREAM_IDLE_TIMEOUT_MS
            }));
          case 14:
            _context24.n = 15;
            return _iterator.next();
          case 15:
            if (!(_iteratorAbruptCompletion = !(_step = _context24.v).done)) {
              _context24.n = 17;
              break;
            }
            outcome = _step.value;
            if (outcome.kind === "event") {
              handleParsedStreamEvent(outcome.json);
            } else if (outcome.kind === "malformed") {
              sendError(new Error("Failed to parse streaming line: ".concat(outcome.line)), {
                component: "ChatContext",
                action: "parse_streaming_line",
                conversationId: streamingConversationId,
                toolName: "streaming_parser"
              });
            } else if (outcome.kind === "done") {
              if (!hasHandedOffToDatabase()) {
                setStreamingMessage(function (currentStreamingMessage) {
                  var _currentStreamingMess2;
                  if (currentStreamingMessage && !(0, _chat.isThinking)(currentStreamingMessage) && ((_currentStreamingMess2 = currentStreamingMessage.turnArtifacts) === null || _currentStreamingMess2 === void 0 ? void 0 : _currentStreamingMess2.type) !== "status" && !currentStreamingMessage.isTransient) {
                    appendMessage({
                      turnType: currentStreamingMessage.turnType,
                      content: currentStreamingMessage.content,
                      turnArtifacts: currentStreamingMessage.turnArtifacts || {},
                      conversationId: streamingConversationId,
                      id: currentStreamingMessage.id,
                      timestamp: currentStreamingMessage.timestamp
                    });
                  }
                  return null;
                });
                Array.from(streamingToolResultsRef.current).forEach(function (toolId) {
                  var completionToolName = "unknown";
                  if (toolId.startsWith("toolu_")) {
                    completionToolName = toolCallIdToToolNameRef.current.get(toolId) || "perplexity";
                  } else if (toolId.startsWith("tool-")) {
                    completionToolName = toolId.split("-")[1];
                  }
                  completeCollapsibleToolResult(completionToolName, toolId);
                });
              }
              streamCompletedNormally = true;
            }
          case 16:
            _iteratorAbruptCompletion = false;
            _context24.n = 14;
            break;
          case 17:
            _context24.n = 19;
            break;
          case 18:
            _context24.p = 18;
            _t20 = _context24.v;
            _didIteratorError = true;
            _iteratorError = _t20;
          case 19:
            _context24.p = 19;
            _context24.p = 20;
            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context24.n = 21;
              break;
            }
            _context24.n = 21;
            return _iterator.return();
          case 21:
            _context24.p = 21;
            if (!_didIteratorError) {
              _context24.n = 22;
              break;
            }
            throw _iteratorError;
          case 22:
            return _context24.f(21);
          case 23:
            return _context24.f(19);
          case 24:
            _context24.p = 24;
            reader.cancel().catch(function () {});
            conversationIdByOpenChatStreamRef.current.delete(openChatStream);
            return _context24.f(24);
          case 25:
            wasUserStop = !!streamingConversationId && userStopRequestedRef.current === streamingConversationId;
            if (wasUserStop) {
              if (selectedConversationIdRef.current === streamingConversationId) {
                markToolsInProgressAsInterrupted();
                setMessagesHistory(_chatStreamReduction.withoutStreamingPreviews);
              }
              userStopRequestedRef.current = undefined;
            }
            if (!(!wasUserStop && !streamCompletedNormally && streamingConversationId && streamingConversationId === selectedConversationIdRef.current)) {
              _context24.n = 27;
              break;
            }
            setStreamingMessage({
              turnType: "assistant",
              content: "Still processing...",
              turnArtifacts: {
                type: "status"
              },
              isTransient: true
            });
            _context24.n = 26;
            return runDatabaseCatchUpPoll(streamingConversationId);
          case 26:
            if (selectedConversationIdRef.current === streamingConversationId) {
              resetToolStatusSnapshots();
            }
            setStreamingMessage(null);
          case 27:
            _context24.n = 29;
            break;
          case 28:
            _context24.p = 28;
            _t21 = _context24.v;
            error = _t21 instanceof Error ? _t21 : new Error(String(_t21));
            setStreamingMessage(null);
            if ((0, _errors.isNetworkError)(error)) {
              onError === null || onError === void 0 || onError(new _errors.UserFacingError("Connection lost during response. Please try again.", error));
            } else if ((0, _streamingFetch.isConversationBusy)(error)) {
              onError === null || onError === void 0 || onError(new _errors.UserFacingError(_streamingFetch.CONVERSATION_BUSY_MESSAGE, error));
              sendError(error, {
                component: "ChatContext",
                action: "chat_stream",
                conversationId: selectedConversationId,
                modelName: options.selectedModel,
                level: "warning"
              });
            } else {
              onError === null || onError === void 0 || onError(error);
              sendError(error, {
                component: "ChatContext",
                action: "chat_stream",
                conversationId: selectedConversationId,
                modelName: options.selectedModel
              });
            }
          case 29:
            _context24.p = 29;
            // Don't clear if a newer stream (e.g. after a conversation switch) already owns the flag.
            setStreamingConversationId(function (prev) {
              return prev === streamingConversationId ? undefined : prev;
            });
            conversationIdByOpenChatStreamRef.current.delete(openChatStream);
            onGeneratingChange === null || onGeneratingChange === void 0 || onGeneratingChange(false);
            return _context24.f(29);
          case 30:
            return _context24.a(2);
        }
      }, _callee24, null, [[20,, 21, 23], [13, 18, 19, 24], [12,, 24, 25], [3, 5], [1, 28, 29, 30]]);
    }));
    return function (_x27, _x28) {
      return _ref33.apply(this, arguments);
    };
  }(), [selectedConversationId, messagesHistory.length, dioptraFetch, dioptraFetchStream, appendMessage, handleAutoRename, applyStreamSideEffects, dispatchStreamEvent, runDatabaseCatchUpPoll, completeCollapsibleToolResult, markToolsInProgressAsInterrupted, sendError]);

  // Thin wrapper — the streaming/event-loop logic lives in `utils/agent-action.ts`.
  var runAgentAction = (0, _react.useCallback)(function (prompt, toolNames, modelName, options) {
    streamedTurnIdRef.current = null;
    var actionConversationId = selectedConversationIdRef.current;
    if (actionConversationId) conversationsAwaitingResponseCheckpointRef.current.add(actionConversationId);
    return (0, _agentAction.runAgentActionStream)({
      dioptraFetchStream: dioptraFetchStream,
      onAddinContentRequest: function onAddinContentRequest(requestId) {
        return handleAddinContentRequest(requestId, {
          kind: "another_agent"
        });
      },
      onJsExecutionRequest: function onJsExecutionRequest(request) {
        return handleJsExecutionRequest(_objectSpread(_objectSpread({}, request), {}, {
          checkpointTarget: {
            conversationId: actionConversationId,
            openDocumentOwnsConversation: conversationMatchesOpenDocumentRef.current
          }
        }));
      },
      prompt: prompt,
      toolNames: toolNames,
      modelName: modelName,
      options: options
    });
  }, [dioptraFetchStream, handleAddinContentRequest, handleJsExecutionRequest]);
  (0, _react.useEffect)(function () {
    var openConversationOnMount = /*#__PURE__*/function () {
      var _ref34 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25() {
        var restorableConversation;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.n) {
            case 0:
              _context25.n = 1;
              return emptyConversationThisDocumentOpenedLast(dioptraFetch);
            case 1:
              restorableConversation = _context25.v;
              if (!selectedConversationIdRef.current) {
                _context25.n = 2;
                break;
              }
              return _context25.a(2);
            case 2:
              if (!restorableConversation) {
                _context25.n = 3;
                break;
              }
              setSelectedConversation(restorableConversation);
              setSelectedConversationId(restorableConversation.id);
              return _context25.a(2);
            case 3:
              _context25.n = 4;
              return createAndSelectConversation("New Conversation");
            case 4:
              return _context25.a(2);
          }
        }, _callee25);
      }));
      return function openConversationOnMount() {
        return _ref34.apply(this, arguments);
      };
    }();
    openConversationOnMount().catch(function (error) {
      console.error("Failed to initialize conversation:", error);
      sendError(error, {
        component: "ChatContext",
        action: "initialize_conversations"
      });
    });
  }, []);
  (0, _react.useEffect)(function () {
    var _selectedConversation;
    if (!selectedConversationId) {
      setSelectedConversation(undefined);
      return;
    }
    if (((_selectedConversation = selectedConversationRef.current) === null || _selectedConversation === void 0 ? void 0 : _selectedConversation.id) === selectedConversationId) return;
    setSelectedConversation(undefined);
    var expectedId = selectedConversationId;
    (0, _webApi.getConversationDetails)(dioptraFetch, expectedId).then(function (conversation) {
      if (selectedConversationIdRef.current === expectedId) {
        setSelectedConversation(conversation);
      }
    }).catch(function (error) {
      if (error instanceof _errors.UserFacingError && error.status === 404) {
        if (selectedConversationIdRef.current === expectedId) {
          setSelectedConversationId(undefined);
        }
        return;
      }
      sendError(error instanceof Error ? error : new Error(String(error)), {
        component: "ChatContext",
        action: "load_selected_conversation",
        conversationId: expectedId
      });
    });
  }, [selectedConversationId]);
  (0, _react.useEffect)(function () {
    if (selectedConversationId) {
      localStorage.setItem(LAST_CONVERSATION_STORAGE_KEY, selectedConversationId);
    }
  }, [selectedConversationId]);
  (0, _react.useEffect)(function () {
    conversationSelectionEpochRef.current += 1;
    var conversationLeftBehind = previouslySelectedConversationIdRef.current;
    previouslySelectedConversationIdRef.current = selectedConversationId;
    if (conversationLeftBehind && conversationLeftBehind !== selectedConversationId) {
      conversationsHandedOffToDatabaseRef.current.add(conversationLeftBehind);
    }
    _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26() {
      var expectedId, toastId, finishLoading, isNew, isReplay, _yield$Promise$all, _yield$Promise$all2, messages, _files2, conversationArtifacts, inFocusFile, matches, _t22;
      return _regenerator().w(function (_context26) {
        while (1) switch (_context26.p = _context26.n) {
          case 0:
            resetSelectedConversationState();
            if (selectedConversationId) {
              _context26.n = 1;
              break;
            }
            setIsConversationLoading(false);
            return _context26.a(2);
          case 1:
            expectedId = selectedConversationId;
            setIsConversationLoading(true);
            toastId = (0, _toast.toastLoading)("Loading conversation...");
            finishLoading = function finishLoading() {
              (0, _toast.toastDismiss)(toastId);
              if (selectedConversationIdRef.current === expectedId) {
                setIsConversationLoading(false);
              }
            };
            isNew = isNewConversationRef.current;
            isNewConversationRef.current = false;
            isReplay = isReplayConversationRef.current;
            isReplayConversationRef.current = false;
            if (!isReplay) {
              _context26.n = 2;
              break;
            }
            finishLoading();
            return _context26.a(2);
          case 2:
            _context26.p = 2;
            if (!isNew) {
              _context26.n = 4;
              break;
            }
            _context26.n = 3;
            return registerFocusedDocument(expectedId);
          case 3:
            if (selectedConversationIdRef.current === expectedId) {
              setConversationMatchesOpenDocument(true);
            }
            _context26.n = 12;
            break;
          case 4:
            _context26.n = 5;
            return Promise.all([(0, _webApi.getMessagesHistory)(dioptraFetch, expectedId), (0, _webApi.getConversationFiles)(dioptraFetch, expectedId), (0, _webApi.getConversationArtifacts)(dioptraFetch, expectedId).catch(function (err) {
              // Non-fatal: stale conversations may predate the artifacts table
              // or the org may not have access. Treat as empty.
              console.warn("Failed to load conversation artifacts", err);
              return [];
            })]);
          case 5:
            _yield$Promise$all = _context26.v;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
            messages = _yield$Promise$all2[0];
            _files2 = _yield$Promise$all2[1];
            conversationArtifacts = _yield$Promise$all2[2];
            if (!(selectedConversationIdRef.current !== expectedId)) {
              _context26.n = 6;
              break;
            }
            return _context26.a(2);
          case 6:
            setMessagesHistory(messages);
            setAttachmentFiles(_files2.filter(function (file) {
              return !file.inFocus;
            }));
            setArtifacts(conversationArtifacts);
            inFocusFile = _files2.find(function (file) {
              return file.inFocus;
            });
            if (!inFocusFile) {
              _context26.n = 9;
              break;
            }
            inFocusFileRef.current = inFocusFile;
            _context26.n = 7;
            return openDocumentOwnsConversation(expectedId, inFocusFile.fileName);
          case 7:
            matches = _context26.v;
            if (!(selectedConversationIdRef.current !== expectedId)) {
              _context26.n = 8;
              break;
            }
            return _context26.a(2);
          case 8:
            console.log("\x1B[35m[backup] conversation ".concat(expectedId, " -> restore ").concat(matches ? "AVAILABLE" : "HIDDEN", "\x1B[0m"));
            setConversationMatchesOpenDocument(matches);
            _context26.n = 12;
            break;
          case 9:
            _context26.n = 10;
            return registerFocusedDocument(expectedId);
          case 10:
            inFocusFile = _context26.v;
            if (!(selectedConversationIdRef.current !== expectedId)) {
              _context26.n = 11;
              break;
            }
            return _context26.a(2);
          case 11:
            setConversationMatchesOpenDocument(true);
          case 12:
            _context26.n = 14;
            break;
          case 13:
            _context26.p = 13;
            _t22 = _context26.v;
            console.error("Failed to load message history:", _t22);
            sendError(_t22, {
              component: "ChatContext",
              action: "load_message_history",
              conversationId: expectedId
            });
          case 14:
            _context26.p = 14;
            finishLoading();
            return _context26.f(14);
          case 15:
            if (!isNew && selectedConversationIdRef.current === expectedId) {
              void runDatabaseCatchUpPoll(expectedId);
            }
          case 16:
            return _context26.a(2);
        }
      }, _callee26, null, [[2, 13, 14, 15]]);
    }))();
  }, [selectedConversationId]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ChatContext.Provider, {
    value: {
      selectedConversation: selectedConversation,
      selectedConversationId: selectedConversationId,
      setSelectedConversationId: setSelectedConversationId,
      pendingScrollTarget: pendingScrollTarget,
      setPendingScrollTarget: setPendingScrollTarget,
      messagesHistory: messagesHistory,
      appendMessage: appendMessage,
      updateMessageById: updateMessageById,
      mergeMessageTurnArtifacts: mergeMessageTurnArtifacts,
      startStreamingMessage: startStreamingMessage,
      updateStreamingMessage: updateStreamingMessage,
      completeStreamingMessage: completeStreamingMessage,
      streamingMessageId: streamingMessageId,
      isConversationLoading: isConversationLoading,
      isSelectedConversationJustCreated: selectedConversationId === justCreatedConversationId,
      createAndSelectConversation: createAndSelectConversation,
      selectConversationForReplay: selectConversationForReplay,
      documentBackups: documentBackups,
      conversationMatchesOpenDocument: conversationMatchesOpenDocument,
      restoringBackupName: restoringBackupName,
      revertDocumentToBackup: revertDocumentToBackup,
      revertDocumentToLatestBackup: revertDocumentToLatestBackup,
      renameConversation: renameConversation,
      appliedActions: appliedActions,
      markActionAsApplied: markActionAsApplied,
      markActionAsUnapplied: markActionAsUnapplied,
      isActionApplied: isActionApplied,
      getActionAppliedAt: getActionAppliedAt,
      dismissedActions: dismissedActions,
      refusedActions: refusedActions,
      markActionAsRefused: markActionAsRefused,
      clearActionRefusal: clearActionRefusal,
      isActionRefused: isActionRefused,
      markActionAsFailed: markActionAsFailed,
      recordActionFailure: recordActionFailure,
      clearActionFailure: clearActionFailure,
      getActionFailure: getActionFailure,
      markActionAsDismissed: markActionAsDismissed,
      markActionAsUndismissed: markActionAsUndismissed,
      isActionDismissed: isActionDismissed,
      isActionDismissalSaving: isActionDismissalSaving,
      markActionAsSuperseded: markActionAsSuperseded,
      getActionSupersession: getActionSupersession,
      markActionAsPartlySuperseded: markActionAsPartlySuperseded,
      getActionPartSupersession: getActionPartSupersession,
      markActionAsRemovedFromConflictGroups: markActionAsRemovedFromConflictGroups,
      isActionRemovedFromConflictGroups: isActionRemovedFromConflictGroups,
      actionRecoveryWarnings: actionRecoveryWarnings,
      markActionWithRecoveryWarning: markActionWithRecoveryWarning,
      getActionRecoveryWarning: getActionRecoveryWarning,
      streamingMessage: streamingMessage,
      isPolling: isPolling,
      pollDetectedActivity: pollDetectedActivity,
      streamingConversationId: streamingConversationId,
      clearStreamingConversation: clearStreamingConversation,
      getChatInputDraft: getChatInputDraft,
      setChatInputDraft: setChatInputDraft,
      streamingToolResults: streamingToolResults,
      toolCallIdToToolId: toolCallIdToToolId,
      toolCallIdToToolName: toolCallIdToToolName,
      toolStatusByCallId: toolStatusByCallId,
      sendMessage: sendMessage,
      dispatchStreamEvent: dispatchStreamEvent,
      flushStreamingMessage: flushStreamingMessage,
      runAgentAction: runAgentAction,
      attachmentFiles: attachmentFiles,
      inFocusFileRef: inFocusFileRef,
      loadingFiles: loadingFiles,
      handleAddFiles: handleAddFiles,
      handleSelectSavedFile: handleSelectSavedFile,
      attachPromptFilesToConversation: attachPromptFilesToConversation,
      handleRemoveFilesClick: handleRemoveFilesClick,
      handleDeleteFileConfirm: handleDeleteFileConfirm,
      handleRemoveSavedFile: handleRemoveSavedFile,
      artifacts: artifacts,
      recentArtifactIds: recentArtifactIds,
      flashingArtifactIds: flashingArtifactIds,
      plusButtonHasArtifactDot: plusButtonHasArtifactDot,
      plusButtonArtifactDotFlashing: plusButtonArtifactDotFlashing,
      chatArtifactsMenuItemHasArtifactDot: chatArtifactsMenuItemHasArtifactDot,
      notifyAddMenuOpen: notifyAddMenuOpen,
      notifyFilesPanelOpen: notifyFilesPanelOpen,
      notifyFilesPanelClose: notifyFilesPanelClose,
      markArtifactSeen: markArtifactSeen,
      handleDeleteArtifact: handleDeleteArtifact,
      handlePromoteArtifact: handlePromoteArtifact
    },
    "data-sentry-element": "ChatContext.Provider",
    "data-sentry-component": "ChatProvider",
    "data-sentry-source-file": "ChatContext.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CardsNotShownContext.CardsNotShownProvider, {
      conversationId: selectedConversationId,
      "data-sentry-element": "CardsNotShownProvider",
      "data-sentry-source-file": "ChatContext.tsx",
      children: children
    })
  });
};
var useChat = exports.useChat = function useChat() {
  var chatContext = (0, _react.useContext)(ChatContext);
  if (!chatContext) {
    throw new Error("useChat must be used within a ChatProvider");
  }
  return chatContext;
};
function documentConversationIds() {
  return _documentConversationIds.apply(this, arguments);
}
function _documentConversationIds() {
  _documentConversationIds = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27() {
    var storedIds;
    return _regenerator().w(function (_context27) {
      while (1) switch (_context27.n) {
        case 0:
          _context27.n = 1;
          return (0, _document.fetchPropertyFromDocSettings)(_constants.DIOPTRA_CHAT_CONVERSATION_ID).catch(function () {
            return null;
          });
        case 1:
          storedIds = _context27.v;
          return _context27.a(2, storedIds ? storedIds.split(",").map(function (id) {
            return id.trim();
          }).filter(Boolean) : []);
      }
    }, _callee27);
  }));
  return _documentConversationIds.apply(this, arguments);
}
function emptyConversationThisDocumentOpenedLast(_x29) {
  return _emptyConversationThisDocumentOpenedLast.apply(this, arguments);
}
function _emptyConversationThisDocumentOpenedLast() {
  _emptyConversationThisDocumentOpenedLast = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(dioptraFetch) {
    var lastConversationId, _conversation$agentIn, conversation, isEmptyGlobalChat, _t23, _t24;
    return _regenerator().w(function (_context28) {
      while (1) switch (_context28.p = _context28.n) {
        case 0:
          lastConversationId = localStorage.getItem(LAST_CONVERSATION_STORAGE_KEY);
          _t23 = !lastConversationId;
          if (_t23) {
            _context28.n = 2;
            break;
          }
          _context28.n = 1;
          return documentConversationIds();
        case 1:
          _t23 = !_context28.v.includes(lastConversationId);
        case 2:
          if (!_t23) {
            _context28.n = 3;
            break;
          }
          return _context28.a(2, null);
        case 3:
          _context28.p = 3;
          _context28.n = 4;
          return (0, _webApi.getConversationDetails)(dioptraFetch, lastConversationId);
        case 4:
          conversation = _context28.v;
          isEmptyGlobalChat = !conversation.lastMessageAt && !conversation.project && !((_conversation$agentIn = conversation.agentInstructions) !== null && _conversation$agentIn !== void 0 && _conversation$agentIn.trim());
          return _context28.a(2, isEmptyGlobalChat ? conversation : null);
        case 5:
          _context28.p = 5;
          _t24 = _context28.v;
          return _context28.a(2, null);
      }
    }, _callee28, null, [[3, 5]]);
  }));
  return _emptyConversationThisDocumentOpenedLast.apply(this, arguments);
}
function setUpNewConversation(_x30) {
  return _setUpNewConversation.apply(this, arguments);
}
function _setUpNewConversation() {
  _setUpNewConversation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(conversation) {
    var existingIds, updatedConversationIds;
    return _regenerator().w(function (_context29) {
      while (1) switch (_context29.n) {
        case 0:
          _context29.n = 1;
          return documentConversationIds();
        case 1:
          existingIds = _context29.v;
          if (!existingIds.includes(conversation.id)) {
            existingIds.push(conversation.id);
          }
          updatedConversationIds = existingIds.join(",");
          _context29.n = 2;
          return (0, _document.setPropertyInDocSettings)("".concat(_constants.DIOPTRA_CHAT_CONVERSATION_ID, "=").concat(updatedConversationIds), false);
        case 2:
          return _context29.a(2);
      }
    }, _callee29);
  }));
  return _setUpNewConversation.apply(this, arguments);
}